export const africa = [
  {
    name: {
      common: 'Botswana',
      official: 'Republic of Botswana',
      nativeName: {
        eng: { official: 'Republic of Botswana', common: 'Botswana' },
        tsn: { official: 'Lefatshe la Botswana', common: 'Botswana' }
      }
    },
    tld: ['.bw'],
    cca2: 'BW',
    ccn3: '072',
    cca3: 'BWA',
    cioc: 'BOT',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { BWP: { name: 'Botswana pula', symbol: 'P' } },
    idd: { root: '+2', suffixes: ['67'] },
    capital: ['Gaborone'],
    altSpellings: ['BW', 'Republic of Botswana', 'Lefatshe la Botswana'],
    region: 'Africa',
    subregion: 'Southern Africa',
    languages: { eng: 'English', tsn: 'Tswana' },
    translations: {
      ara: { official: 'جمهورية بوتسوانا', common: 'بوتسوانا' },
      bre: { official: 'Republik Botswana', common: 'Botswana' },
      ces: { official: 'Botswanská republika', common: 'Botswana' },
      cym: { official: 'Republic of Botswana', common: 'Botswana' },
      deu: { official: 'Republik Botsuana', common: 'Botswana' },
      est: { official: 'Botswana Vabariik', common: 'Botswana' },
      fin: { official: 'Botswanan tasavalta', common: 'Botswana' },
      fra: { official: 'République du Botswana', common: 'Botswana' },
      hrv: { official: 'Republika Bocvana', common: 'Bocvana' },
      hun: { official: 'Botswanai Köztársaság', common: 'Botswana' },
      ita: { official: 'Repubblica del Botswana', common: 'Botswana' },
      jpn: { official: 'ボツワナ共和国', common: 'ボツワナ' },
      kor: { official: '보츠와나 공화국', common: '보츠와나' },
      nld: { official: 'Republiek Botswana', common: 'Botswana' },
      per: { official: 'جمهوری بوتسوانا', common: 'بوتسوانا' },
      pol: { official: 'Republika Botswany', common: 'Botswana' },
      por: { official: 'República do Botswana', common: 'Botswana' },
      rus: { official: 'Республика Ботсвана', common: 'Ботсвана' },
      slk: { official: 'Botswanská republika', common: 'Botswana' },
      spa: { official: 'República de Botswana', common: 'Botswana' },
      swe: { official: 'Republiken Botswana', common: 'Botswana' },
      tur: { official: 'Botsvana Cumhuriyeti', common: 'Botsvana' },
      urd: { official: 'جمہوریہ بوٹسوانا', common: 'بوٹسوانا' },
      zho: { official: '博茨瓦纳共和国', common: '博茨瓦纳' }
    },
    latlng: [-22.0, 24.0],
    landlocked: true,
    borders: ['NAM', 'ZAF', 'ZMB', 'ZWE'],
    area: 582000.0,
    demonyms: {
      eng: { f: 'Motswana', m: 'Motswana' },
      fra: { f: 'Botswanaise', m: 'Botswanais' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/E364KeLy6N4JwxwQ8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1889339'
    },
    population: 2351625,
    gini: { 2015: 53.3 },
    fifa: 'BOT',
    car: { signs: ['BW'], side: 'left' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/bw.png',
      svg: 'https://flagcdn.com/bw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bw.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-24.63, 25.9] }
  },
  {
    name: {
      common: 'Ivory Coast',
      official: "Republic of Côte d'Ivoire",
      nativeName: {
        fra: {
          official: "République de Côte d'Ivoire",
          common: "Côte d'Ivoire"
        }
      }
    },
    tld: ['.ci'],
    cca2: 'CI',
    ccn3: '384',
    cca3: 'CIV',
    cioc: 'CIV',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XOF: { name: 'West African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['25'] },
    capital: ['Yamoussoukro'],
    altSpellings: [
      'CI',
      "Côte d'Ivoire",
      'Ivory Coast',
      "Republic of Côte d'Ivoire",
      "République de Côte d'Ivoire"
    ],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جمهورية ساحل العاج', common: 'ساحل العاج' },
      bre: { official: 'Republik Aod an Olifant', common: 'Aod an Olifant' },
      ces: {
        official: 'Republika Pobřeží slonoviny',
        common: 'Pobřeží slonoviny'
      },
      cym: { official: "Republic of Côte d'Ivoire", common: 'Ivory Coast' },
      deu: { official: "Republik Côte d'Ivoire", common: 'Elfenbeinküste' },
      est: {
        official: 'Côte d’Ivoire’i Vabariik',
        common: 'Elevandiluurannik'
      },
      fin: {
        official: 'Norsunluurannikon tasavalta',
        common: 'Norsunluurannikko'
      },
      fra: {
        official: "République de Côte d' Ivoire",
        common: "Côte d'Ivoire"
      },
      hrv: { official: "Republika Côte d'Ivoire", common: 'Obala Bjelokosti' },
      hun: {
        official: 'Elefántcsontparti Köztársaság',
        common: 'Elefántcsontpart'
      },
      ita: {
        official: "Repubblica della Costa d'Avorio",
        common: "Costa d'Avorio"
      },
      jpn: { official: 'コートジボワール共和国', common: 'コートジボワール' },
      kor: { official: '코트디부아르 공화국', common: '코트디부아르' },
      nld: { official: 'Republiek Ivoorkust', common: 'Ivoorkust' },
      per: { official: 'جمهوری ساحل عاج', common: 'ساحل عاج' },
      pol: {
        official: 'Republika WybrzeŻa Kości Słoniowej',
        common: 'WybrzeŻe Kości Słoniowej'
      },
      por: {
        official: "República da Côte d'Ivoire",
        common: 'Costa do Marfim'
      },
      rus: { official: "Республика Кот-д'Ивуаре", common: 'Кот-д’Ивуар' },
      slk: {
        official: 'Republika Pobrežie Slonoviny',
        common: 'Pobržie Slonoviny'
      },
      spa: {
        official: "República de Côte d'Ivoire",
        common: 'Costa de Marfil'
      },
      swe: {
        official: 'Republiken Elfenbenskusten',
        common: 'Elfenbenskusten'
      },
      tur: { official: 'Fildişi Sahili', common: 'Fildişi Sahili' },
      urd: { official: 'جمہوریہ کوت دیواغ', common: 'آئیوری کوسٹ' },
      zho: { official: '科特迪瓦共和国', common: '科特迪瓦' }
    },
    latlng: [8.0, -5.0],
    landlocked: false,
    borders: ['BFA', 'GHA', 'GIN', 'LBR', 'MLI'],
    area: 322463.0,
    demonyms: {
      eng: { f: 'Ivorian', m: 'Ivorian' },
      fra: { f: 'Ivoirienne', m: 'Ivoirien' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDEE',
    maps: {
      googleMaps: 'https://goo.gl/maps/wKsmN7f5qAeNtGjP6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192779'
    },
    population: 26378275,
    gini: { 2015: 41.5 },
    fifa: 'CIV',
    car: { signs: ['CI'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ci.png',
      svg: 'https://flagcdn.com/ci.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ci.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ci.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [6.82, -5.27] }
  },
  {
    name: {
      common: 'Guinea',
      official: 'Republic of Guinea',
      nativeName: {
        fra: { official: 'République de Guinée', common: 'Guinée' }
      }
    },
    tld: ['.gn'],
    cca2: 'GN',
    ccn3: '324',
    cca3: 'GIN',
    cioc: 'GUI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { GNF: { name: 'Guinean franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['24'] },
    capital: ['Conakry'],
    altSpellings: ['GN', 'Republic of Guinea', 'République de Guinée'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جمهورية غينيا', common: 'غينيا' },
      bre: { official: 'Republik Ginea', common: 'Ginea' },
      ces: { official: 'Guinejská republika', common: 'Guinea' },
      cym: { official: 'Republic of Guinea', common: 'Guinea' },
      deu: { official: 'Republik Guinea', common: 'Guinea' },
      est: { official: 'Guinea Vabariik', common: 'Guinea' },
      fin: { official: 'Guinean tasavalta', common: 'Guinea' },
      fra: { official: 'République de Guinée', common: 'Guinée' },
      hrv: { official: 'Republika Gvineja', common: 'Gvineja' },
      hun: { official: 'Guineai Köztársaság', common: 'Guinea' },
      ita: { official: 'Repubblica di Guinea', common: 'Guinea' },
      jpn: { official: 'ギニア共和国', common: 'ギニア' },
      kor: { official: '기니 공화국', common: '기니' },
      nld: { official: 'Republiek Guinee', common: 'Guinee' },
      per: { official: 'مملکت مستقل پاپوآ گینه نو', common: 'پاپوآ گینه نو' },
      pol: { official: 'Republika Gwinei', common: 'Gwinea' },
      por: { official: 'República da Guiné', common: 'Guiné' },
      rus: { official: 'Республика Гвинея', common: 'Гвинея' },
      slk: { official: 'Guinejská republika', common: 'Guinea' },
      spa: { official: 'República de Guinea', common: 'Guinea' },
      swe: { official: 'Republiken Guinea', common: 'Guinea' },
      tur: { official: 'Gine Cumhuriyeti', common: 'Gine' },
      urd: { official: 'جمہوریہ گنی', common: 'گنی' },
      zho: { official: '几内亚共和国', common: '几内亚' }
    },
    latlng: [11.0, -10.0],
    landlocked: false,
    borders: ['CIV', 'GNB', 'LBR', 'MLI', 'SEN', 'SLE'],
    area: 245857.0,
    demonyms: {
      eng: { f: 'Guinean', m: 'Guinean' },
      fra: { f: 'Guinéenne', m: 'Guinéen' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/8J5oM5sA4Ayr1ZYGA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192778'
    },
    population: 13132792,
    gini: { 2012: 33.7 },
    fifa: 'GUI',
    car: { signs: ['RG'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/gn.png',
      svg: 'https://flagcdn.com/gn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [9.5, -13.7] }
  },
  {
    name: {
      common: 'Senegal',
      official: 'Republic of Senegal',
      nativeName: {
        fra: { official: 'République du Sénégal', common: 'Sénégal' }
      }
    },
    tld: ['.sn'],
    cca2: 'SN',
    ccn3: '686',
    cca3: 'SEN',
    cioc: 'SEN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XOF: { name: 'West African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['21'] },
    capital: ['Dakar'],
    altSpellings: ['SN', 'Republic of Senegal', 'République du Sénégal'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جمهورية السنغال', common: 'السنغال' },
      bre: { official: 'Republik Senegal', common: 'Senegal' },
      ces: { official: 'Senegalská republika', common: 'Senegal' },
      cym: { official: 'Republic of Senegal', common: 'Senegal' },
      deu: { official: 'Republik Senegal', common: 'Senegal' },
      est: { official: 'Senegali Vabariik', common: 'Senegal' },
      fin: { official: 'Senegalin tasavalta', common: 'Senegal' },
      fra: { official: 'République du Sénégal', common: 'Sénégal' },
      hrv: { official: 'Republika Senegal', common: 'Senegal' },
      hun: { official: 'Szenegáli Köztársaság', common: 'Szenegál' },
      ita: { official: 'Repubblica del Senegal', common: 'Senegal' },
      jpn: { official: 'セネガル共和国', common: 'セネガル' },
      kor: { official: '세네갈 공화국', common: '세네갈' },
      nld: { official: 'Republiek Senegal', common: 'Senegal' },
      per: { official: 'جمهوری سنگال', common: 'سنگال' },
      pol: { official: 'Senegal', common: 'Senegal' },
      por: { official: 'República do Senegal', common: 'Senegal' },
      rus: { official: 'Республика Сенегал', common: 'Сенегал' },
      slk: { official: 'Senegalská republika', common: 'Senegal' },
      spa: { official: 'República de Senegal', common: 'Senegal' },
      swe: { official: 'Republiken Senegal', common: 'Senegal' },
      tur: { official: 'Senegal Cumhuriyeti', common: 'Senegal' },
      urd: { official: 'جمہوریہ سینیگال', common: 'سینیگال' },
      zho: { official: '塞内加尔共和国', common: '塞内加尔' }
    },
    latlng: [14.0, -14.0],
    landlocked: false,
    borders: ['GMB', 'GIN', 'GNB', 'MLI', 'MRT'],
    area: 196722.0,
    demonyms: {
      eng: { f: 'Senegalese', m: 'Senegalese' },
      fra: { f: 'Sénégalaise', m: 'Sénégalais' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/o5f1uD5nyihCL3HCA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192775'
    },
    population: 16743930,
    gini: { 2011: 40.3 },
    fifa: 'SEN',
    car: { signs: ['SN'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/sn.png',
      svg: 'https://flagcdn.com/sn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [14.73, -17.63] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Eritrea',
      official: 'State of Eritrea',
      nativeName: {
        ara: { official: 'دولة إرتريا', common: 'إرتريا‎' },
        eng: { official: 'State of Eritrea', common: 'Eritrea' },
        tir: { official: 'ሃገረ ኤርትራ', common: 'ኤርትራ' }
      }
    },
    tld: ['.er'],
    cca2: 'ER',
    ccn3: '232',
    cca3: 'ERI',
    cioc: 'ERI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { ERN: { name: 'Eritrean nakfa', symbol: 'Nfk' } },
    idd: { root: '+2', suffixes: ['91'] },
    capital: ['Asmara'],
    altSpellings: [
      'ER',
      'State of Eritrea',
      'ሃገረ ኤርትራ',
      'Dawlat Iritriyá',
      'ʾErtrā',
      'Iritriyā'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { ara: 'Arabic', eng: 'English', tir: 'Tigrinya' },
    translations: {
      ara: { official: 'دولة إريتريا', common: 'إريتريا' },
      bre: { official: 'Stad Eritrea', common: 'Eritrea' },
      ces: { official: 'Stát Eritrea', common: 'Eritrea' },
      cym: { official: 'Gwladwriaeth Eritrea', common: 'Eritrea' },
      deu: { official: 'Staat Eritrea', common: 'Eritrea' },
      est: { official: 'Eritrea Riik', common: 'Eritrea' },
      fin: { official: 'Eritrean valtio', common: 'Eritrea' },
      fra: { official: "État d'Érythrée", common: 'Érythrée' },
      hrv: { official: 'Država Eritreji', common: 'Eritreja' },
      hun: { official: 'Eritrea', common: 'Eritrea' },
      ita: { official: 'Stato di Eritrea', common: 'Eritrea' },
      jpn: { official: 'エリトリア国', common: 'エリトリア' },
      kor: { official: '에리트레아국', common: '에리트레아' },
      nld: { official: 'Staat Eritrea', common: 'Eritrea' },
      per: { official: 'جمهوری اریتره', common: 'اریتره' },
      pol: { official: 'Państwo Erytrea', common: 'Erytrea' },
      por: { official: 'Estado da Eritreia', common: 'Eritreia' },
      rus: { official: 'Государство Эритрея', common: 'Эритрея' },
      slk: { official: 'Eritrejský štát', common: 'Eritrea' },
      spa: { official: 'Estado de Eritrea', common: 'Eritrea' },
      swe: { official: 'Staten Eritrea', common: 'Eritrea' },
      tur: { official: 'Eritre Devleti', common: 'Eritre' },
      urd: { official: 'ریاستِ ارتریا', common: 'ارتریا' },
      zho: { official: '厄立特里亚', common: '厄立特里亚' }
    },
    latlng: [15.0, 39.0],
    landlocked: false,
    borders: ['DJI', 'ETH', 'SDN'],
    area: 117600.0,
    demonyms: {
      eng: { f: 'Eritrean', m: 'Eritrean' },
      fra: { f: 'Érythréenne', m: 'Érythréen' }
    },
    flag: '\uD83C\uDDEA\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/HRyqUpnPwwG6jY5j6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/296961'
    },
    population: 5352000,
    fifa: 'ERI',
    car: { signs: ['ER'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/er.png',
      svg: 'https://flagcdn.com/er.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/er.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/er.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [15.33, 38.93] }
  },
  {
    name: {
      common: 'Mali',
      official: 'Republic of Mali',
      nativeName: { fra: { official: 'République du Mali', common: 'Mali' } }
    },
    tld: ['.ml'],
    cca2: 'ML',
    ccn3: '466',
    cca3: 'MLI',
    cioc: 'MLI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XOF: { name: 'West African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['23'] },
    capital: ['Bamako'],
    altSpellings: ['ML', 'Republic of Mali', 'République du Mali'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جمهورية مالي', common: 'مالي' },
      bre: { official: 'Republik Mali', common: 'Mali' },
      ces: { official: 'Republika Mali', common: 'Mali' },
      cym: { official: 'Republic of Mali', common: 'Mali' },
      deu: { official: 'Republik Mali', common: 'Mali' },
      est: { official: 'Mali Vabariik', common: 'Mali' },
      fin: { official: 'Malin tasavalta', common: 'Mali' },
      fra: { official: 'République du Mali', common: 'Mali' },
      hrv: { official: 'Republika Mali', common: 'Mali' },
      hun: { official: 'Mali Köztársaság', common: 'Mali' },
      ita: { official: 'Repubblica del Mali', common: 'Mali' },
      jpn: { official: 'マリ共和国', common: 'マリ' },
      kor: { official: '말리 공화국', common: '말리' },
      nld: { official: 'Republiek Mali', common: 'Mali' },
      per: { official: 'جمهوری مالی', common: 'مالی' },
      pol: { official: 'Republika Mali', common: 'Mali' },
      por: { official: 'República do Mali', common: 'Mali' },
      rus: { official: 'Республика Мали', common: 'Мали' },
      slk: { official: 'Malijská republika', common: 'Mali' },
      spa: { official: 'República de Malí', common: 'Mali' },
      swe: { official: 'Republiken Mali', common: 'Mali' },
      tur: { official: 'Mali Cumhuriyeti', common: 'Mali' },
      urd: { official: 'جمہوریہ مالی', common: 'مالی' },
      zho: { official: '马里共和国', common: '马里' }
    },
    latlng: [17.0, -4.0],
    landlocked: true,
    borders: ['DZA', 'BFA', 'GIN', 'CIV', 'MRT', 'NER', 'SEN'],
    area: 1240192.0,
    demonyms: {
      eng: { f: 'Malian', m: 'Malian' },
      fra: { f: 'Malienne', m: 'Malien' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDF1',
    maps: {
      googleMaps: 'https://goo.gl/maps/u9mYJkCB19wyuzh27',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192785'
    },
    population: 20250834,
    gini: { 2009: 33.0 },
    fifa: 'MLI',
    car: { signs: ['RMM'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ml.png',
      svg: 'https://flagcdn.com/ml.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ml.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ml.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [12.65, -8.0] }
  },
  {
    name: {
      common: 'Namibia',
      official: 'Republic of Namibia',
      nativeName: {
        afr: { official: 'Republiek van Namibië', common: 'Namibië' },
        deu: { official: 'Republik Namibia', common: 'Namibia' },
        eng: { official: 'Republic of Namibia', common: 'Namibia' },
        her: { official: 'Republic of Namibia', common: 'Namibia' },
        hgm: { official: 'Republic of Namibia', common: 'Namibia' },
        kwn: { official: 'Republic of Namibia', common: 'Namibia' },
        loz: { official: 'Republic of Namibia', common: 'Namibia' },
        ndo: { official: 'Republic of Namibia', common: 'Namibia' },
        tsn: { official: 'Lefatshe la Namibia', common: 'Namibia' }
      }
    },
    tld: ['.na'],
    cca2: 'NA',
    ccn3: '516',
    cca3: 'NAM',
    cioc: 'NAM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      NAD: { name: 'Namibian dollar', symbol: '$' },
      ZAR: { name: 'South African rand', symbol: 'R' }
    },
    idd: { root: '+2', suffixes: ['64'] },
    capital: ['Windhoek'],
    altSpellings: ['NA', 'Namibië', 'Republic of Namibia'],
    region: 'Africa',
    subregion: 'Southern Africa',
    languages: {
      afr: 'Afrikaans',
      deu: 'German',
      eng: 'English',
      her: 'Herero',
      hgm: 'Khoekhoe',
      kwn: 'Kwangali',
      loz: 'Lozi',
      ndo: 'Ndonga',
      tsn: 'Tswana'
    },
    translations: {
      ara: { official: 'جمهورية ناميبيا', common: 'ناميبيا' },
      bre: { official: 'Republik Namibia', common: 'Namibia' },
      ces: { official: 'Namibijská republika', common: 'Namibie' },
      cym: { official: 'Republic of Namibia', common: 'Namibia' },
      deu: { official: 'Republik Namibia', common: 'Namibia' },
      est: { official: 'Namiibia Vabariik', common: 'Namiibia' },
      fin: { official: 'Namibian tasavalta', common: 'Namibia' },
      fra: { official: 'République de Namibie', common: 'Namibie' },
      hrv: { official: 'Republika Namibija', common: 'Namibija' },
      hun: { official: 'Namíbiai Köztársaság', common: 'Namíbia' },
      ita: { official: 'Repubblica di Namibia', common: 'Namibia' },
      jpn: { official: 'ナミビア共和国', common: 'ナミビア' },
      kor: { official: '나미비아 공화국', common: '나미비아' },
      nld: { official: 'Republiek Namibië', common: 'Namibië' },
      per: { official: 'جمهوری نامیبیا', common: 'نامیبیا' },
      pol: { official: 'Republika Namibii', common: 'Namibia' },
      por: { official: 'República da Namíbia', common: 'Namíbia' },
      rus: { official: 'Республика Намибия', common: 'Намибия' },
      slk: { official: 'Namíbijská republika', common: 'Namíbia' },
      spa: { official: 'República de Namibia', common: 'Namibia' },
      swe: { official: 'Republiken Namibia', common: 'Namibia' },
      tur: { official: 'Namibya Cumhuriyeti', common: 'Namibya' },
      urd: { official: 'جمہوریہ نمیبیا', common: 'نمیبیا' },
      zho: { official: '纳米比亚共和国', common: '纳米比亚' }
    },
    latlng: [-22.0, 17.0],
    landlocked: false,
    borders: ['AGO', 'BWA', 'ZAF', 'ZMB'],
    area: 825615.0,
    demonyms: {
      eng: { f: 'Namibian', m: 'Namibian' },
      fra: { f: 'Namibienne', m: 'Namibien' }
    },
    flag: '\uD83C\uDDF3\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://goo.gl/maps/oR1i8BFEYX3EY83WA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/195266'
    },
    population: 2540916,
    gini: { 2015: 59.1 },
    fifa: 'NAM',
    car: { signs: ['NAM'], side: 'left' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/na.png',
      svg: 'https://flagcdn.com/na.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/na.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/na.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-22.57, 17.08] }
  },
  {
    name: {
      common: 'Gambia',
      official: 'Republic of the Gambia',
      nativeName: {
        eng: { official: 'Republic of the Gambia', common: 'Gambia' }
      }
    },
    tld: ['.gm'],
    cca2: 'GM',
    ccn3: '270',
    cca3: 'GMB',
    cioc: 'GAM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { GMD: { name: 'dalasi', symbol: 'D' } },
    idd: { root: '+2', suffixes: ['20'] },
    capital: ['Banjul'],
    altSpellings: ['GM', 'Republic of the Gambia'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية غامبيا', common: 'غامبيا' },
      bre: { official: 'Republik islamek ar Gambia', common: 'Gambia' },
      ces: { official: 'Gambijská republika', common: 'Gambie' },
      cym: { official: 'Republic of the Gambia', common: 'Gambia' },
      deu: { official: 'Republik Gambia', common: 'Gambia' },
      est: { official: 'Gambia Vabariik', common: 'Gambia' },
      fin: { official: 'Gambian tasavalta', common: 'Gambia' },
      fra: { official: 'République de Gambie', common: 'Gambie' },
      hrv: { official: 'Republika Gambija', common: 'Gambija' },
      hun: { official: 'Gambiai Köztársaság', common: 'Gambia' },
      ita: { official: 'Repubblica del Gambia', common: 'Gambia' },
      jpn: { official: 'ガンビア共和国', common: 'ガンビア' },
      kor: { official: '감비아 공화국', common: '감비아' },
      nld: { official: 'Republiek Gambia', common: 'Gambia' },
      per: { official: 'جمهوری گامبیا', common: 'گامبیا' },
      pol: { official: 'Republika Gambii', common: 'Gambia' },
      por: { official: 'República da Gâmbia', common: 'Gâmbia' },
      rus: { official: 'Республика Гамбия', common: 'Гамбия' },
      slk: { official: 'Gambijská republika', common: 'Gambia' },
      spa: { official: 'República de Gambia', common: 'Gambia' },
      swe: { official: 'Republiken Gambia', common: 'Gambia' },
      tur: { official: 'Gambiya Cumhuriyeti', common: 'Gambiya' },
      urd: { official: 'جمہوریہ گیمبیا', common: 'گیمبیا' },
      zho: { official: '冈比亚共和国', common: '冈比亚' }
    },
    latlng: [13.46666666, -16.56666666],
    landlocked: false,
    borders: ['SEN'],
    area: 10689.0,
    demonyms: {
      eng: { f: 'Gambian', m: 'Gambian' },
      fra: { f: 'Gambienne', m: 'Gambien' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/bbGBCxxtfD2A9Z4m6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192774'
    },
    population: 2416664,
    gini: { 2015: 35.9 },
    fifa: 'GAM',
    car: { signs: ['WAG'], side: 'right' },
    timezones: ['UTC+00:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/gm.png',
      svg: 'https://flagcdn.com/gm.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gm.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gm.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [13.45, -16.57] }
  },
  {
    name: {
      common: 'Morocco',
      official: 'Kingdom of Morocco',
      nativeName: {
        ara: { official: 'المملكة المغربية', common: 'المغرب' },
        ber: { official: 'ⵜⴰⴳⵍⴷⵉⵜ ⵏ ⵍⵎⵖⵔⵉⴱ', common: 'ⵍⵎⴰⵖⵔⵉⴱ' }
      }
    },
    tld: ['.ma', 'المغرب.'],
    cca2: 'MA',
    ccn3: '504',
    cca3: 'MAR',
    cioc: 'MAR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MAD: { name: 'Moroccan dirham', symbol: 'د.م.' } },
    idd: { root: '+2', suffixes: ['12'] },
    capital: ['Rabat'],
    altSpellings: ['MA', 'Kingdom of Morocco', 'Al-Mamlakah al-Maġribiyah'],
    region: 'Africa',
    subregion: 'Northern Africa',
    languages: { ara: 'Arabic', ber: 'Berber' },
    translations: {
      ara: { official: 'المملكة المغربية', common: 'المغرب' },
      bre: { official: 'Rouantelezh Maroko', common: 'Maroko' },
      ces: { official: 'Marocké království', common: 'Maroko' },
      cym: { official: 'Kingdom of Morocco', common: 'Morocco' },
      deu: { official: 'Königreich Marokko', common: 'Marokko' },
      est: { official: 'Maroko Kuningriik', common: 'Maroko' },
      fin: { official: 'Marokon kuningaskunta', common: 'Marokko' },
      fra: { official: 'Royaume du Maroc', common: 'Maroc' },
      hrv: { official: 'Kraljevina Maroko', common: 'Maroko' },
      hun: { official: 'Marokkói Királyság', common: 'Marokkó' },
      ita: { official: 'Regno del Marocco', common: 'Marocco' },
      jpn: { official: 'モロッコ王国', common: 'モロッコ' },
      kor: { official: '모로코 왕국', common: '모로코' },
      nld: { official: 'Koninkrijk Marokko', common: 'Marokko' },
      per: { official: 'پادشاهی مراکش', common: 'مراکش' },
      pol: { official: 'Królestwo Marokańskie', common: 'Maroko' },
      por: { official: 'Reino de Marrocos', common: 'Marrocos' },
      rus: { official: 'Королевство Марокко', common: 'Марокко' },
      slk: { official: 'Marocké kniežatstvo', common: 'Maroko' },
      spa: { official: 'Reino de Marruecos', common: 'Marruecos' },
      swe: { official: 'Konungariket Marocko', common: 'Marocko' },
      tur: { official: 'Fas Krallığı', common: 'Fas' },
      urd: { official: 'مملکتِ مراکش', common: 'مراکش' },
      zho: { official: '摩洛哥王国', common: '摩洛哥' }
    },
    latlng: [32.0, -5.0],
    landlocked: false,
    borders: ['DZA', 'ESH', 'ESP'],
    area: 446550.0,
    demonyms: {
      eng: { f: 'Moroccan', m: 'Moroccan' },
      fra: { f: 'Marocaine', m: 'Marocain' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://goo.gl/maps/6oMv3dyBZg3iaXQ5A',
      openStreetMaps: 'https://www.openstreetmap.org/relation/3630439'
    },
    population: 36910558,
    gini: { 2013: 39.5 },
    fifa: 'MAR',
    car: { signs: ['MA'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ma.png',
      svg: 'https://flagcdn.com/ma.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ma.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ma.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [34.02, -6.82] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Saint Helena, Ascension and Tristan da Cunha',
      official: 'Saint Helena, Ascension and Tristan da Cunha',
      nativeName: {
        eng: {
          official: 'Saint Helena, Ascension and Tristan da Cunha',
          common: 'Saint Helena, Ascension and Tristan da Cunha'
        }
      }
    },
    tld: ['.sh', '.ac'],
    cca2: 'SH',
    ccn3: '654',
    cca3: 'SHN',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: {
      GBP: { name: 'Pound sterling', symbol: '£' },
      SHP: { name: 'Saint Helena pound', symbol: '£' }
    },
    idd: { root: '+2', suffixes: ['90', '47'] },
    capital: ['Jamestown'],
    altSpellings: [
      'Saint Helena',
      'St. Helena, Ascension and Tristan da Cunha'
    ],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'سانت هيلينا وأسينشين وتريستان دا كونا',
        common: 'سانت هيلينا وأسينشين وتريستان دا كونا'
      },
      bre: {
        official: 'Saint Helena, Ascension ha Tristan da Cunha',
        common: 'Saint Helena, Ascension ha Tristan da Cunha'
      },
      ces: {
        official: 'Svatá Helena, Ascension a Tristan da Cunha',
        common: 'Svatá Helena, Ascension a Tristan da Cunha'
      },
      cym: {
        official: 'Saint Helena, Ascension and Tristan da Cunha',
        common: 'Saint Helena, Ascension and Tristan da Cunha'
      },
      deu: {
        official: 'Sankt Helena, Ascension und Tristan da Cunha',
        common: 'St. Helena, Ascension und Tristan da Cunha'
      },
      est: {
        official: 'Saint Helena, Ascension ja Tristan da Cunha',
        common: 'Saint Helena, Ascension ja Tristan da Cunha'
      },
      fin: {
        official: 'Saint Helena, Ascension ja Tristan da Cunha',
        common: 'Saint Helena, Ascension ja Tristan da Cunha'
      },
      fra: {
        official: 'Sainte-Hélène, Ascension et Tristan da Cunha',
        common: 'Sainte-Hélène, Ascension et Tristan da Cunha'
      },
      hrv: { official: 'Sveta Helena', common: 'Sveta Helena' },
      hun: { official: 'Szent Ilona', common: 'Szent Ilona-sziget' },
      ita: {
        official: "Sant'Elena, Ascensione e Tristan da Cunha",
        common: "Sant'Elena, Ascensione e Tristan da Cunha"
      },
      jpn: {
        official: 'セントヘレナ・アセンションおよびトリスタンダクーニャ',
        common: 'セントヘレナ・アセンションおよびトリスタンダクーニャ'
      },
      kor: { official: '세인트헬레나', common: '세인트헬레나' },
      nld: {
        official: 'Sint-Helena, Ascension en Tristan da Cunha',
        common: 'Sint-Helena, Ascension en Tristan da Cunha'
      },
      per: { official: 'سنت هلن', common: 'سنت هلن' },
      pol: {
        official:
          'Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha',
        common:
          'Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha'
      },
      por: {
        official: 'Santa Helena, Ascensão e Tristão da Cunha',
        common: 'Santa Helena, Ascensão e Tristão da Cunha'
      },
      rus: {
        official: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья',
        common: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья'
      },
      slk: {
        official: 'Svätá Helena (zámorské územie)',
        common: 'Svätá Helena (zámorské územie)'
      },
      spa: {
        official: 'Santa Elena, Ascensión y Tristán de Acuña',
        common: 'Santa Elena, Ascensión y Tristán de Acuña'
      },
      swe: { official: 'Sankta Helena', common: 'Sankta Helena' },
      tur: { official: 'Saint Helena', common: 'Saint Helena' },
      urd: {
        official: 'سینٹ ہلینا، اسینشن و ترسٹان دا کونیا',
        common: 'سینٹ ہلینا، اسینشن و ترسٹان دا کونیا'
      },
      zho: {
        official: '圣赫勒拿、阿森松和特里斯坦-达库尼亚',
        common: '圣赫勒拿、阿森松和特里斯坦-达库尼亚'
      }
    },
    latlng: [-15.95, -5.72],
    landlocked: false,
    area: 394.0,
    demonyms: {
      eng: { f: 'Saint Helenian', m: 'Saint Helenian' },
      fra: { f: 'Sainte-Hélénoise', m: 'Sainte-Hélènois' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDED',
    maps: {
      googleMaps: 'https://goo.gl/maps/iv4VxnPzHkjLCJuc6',
      openStreetMaps:
        'https://www.openstreetmap.org/relation/4868269#map=13/-15.9657/-5.7120'
    },
    population: 53192,
    car: { signs: ['GB'], side: 'left' },
    timezones: ['UTC+00:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/sh.png',
      svg: 'https://flagcdn.com/sh.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-15.93, -5.72] },
    postalCode: { format: 'STHL 1ZZ', regex: '^(STHL1ZZ)$' }
  },
  {
    name: {
      common: 'São Tomé and Príncipe',
      official: 'Democratic Republic of São Tomé and Príncipe',
      nativeName: {
        por: {
          official: 'República Democrática do São Tomé e Príncipe',
          common: 'São Tomé e Príncipe'
        }
      }
    },
    tld: ['.st'],
    cca2: 'ST',
    ccn3: '678',
    cca3: 'STP',
    cioc: 'STP',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { STN: { name: 'São Tomé and Príncipe dobra', symbol: 'Db' } },
    idd: { root: '+2', suffixes: ['39'] },
    capital: ['São Tomé'],
    altSpellings: [
      'ST',
      'Democratic Republic of São Tomé and Príncipe',
      'Sao Tome and Principe',
      'República Democrática de São Tomé e Príncipe'
    ],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { por: 'Portuguese' },
    translations: {
      ara: {
        official: 'جمهورية ساو تومي وبرينسيب الديمقراطية',
        common: 'ساو تومي وبرينسيب'
      },
      bre: {
        official: 'Republik Demokratel São Tomé ha Príncipe',
        common: 'São Tomé ha Príncipe'
      },
      ces: {
        official: 'Demokratická republika Svatý Tomáš a Princův ostrov',
        common: 'Svatý Tomáš a Princův ostrov'
      },
      cym: {
        official: 'Democratic Republic of São Tomé and Príncipe',
        common: 'São Tomé and Príncipe'
      },
      deu: {
        official: 'Demokratische Republik São Tomé und Príncipe',
        common: 'São Tomé und Príncipe'
      },
      est: {
        official: 'São Tomé ja Príncipe Demokraatlik Vabariik',
        common: 'São Tomé ja Príncipe'
      },
      fin: {
        official: 'São Tomé ja Príncipen demokraattinen tasavalta',
        common: 'São Téme ja Príncipe'
      },
      fra: {
        official: 'République démocratique de São Tomé et Príncipe',
        common: 'São Tomé et Príncipe'
      },
      hrv: {
        official: 'Demokratska Republika São Tome i Principe',
        common: 'Sveti Toma i Princip'
      },
      hun: {
        official: 'São Tomé és Príncipe Demokratikus Köztársaság',
        common: 'São Tomé és Príncipe'
      },
      ita: {
        official: 'Repubblica democratica di São Tomé e Príncipe',
        common: 'São Tomé e Príncipe'
      },
      jpn: {
        official: 'サントメ·プリンシペ民主共和国',
        common: 'サントメ・プリンシペ'
      },
      kor: {
        official: '상투메 프린시페 민주 공화국',
        common: '상투메 프린시페'
      },
      nld: {
        official: 'Democratische Republiek Sao Tomé en Principe',
        common: 'Sao Tomé en Principe'
      },
      per: {
        official: 'جمهوری دموکراتیک سائوتومه و پرنسیپ',
        common: 'سائوتومه و پرنسیپ'
      },
      pol: {
        official: 'Demokratyczna Republika Wysp Świętego Tomasza i Książęcej',
        common: 'Wyspy Świętego Tomasza i Książęca'
      },
      por: {
        official: 'República Democrática de São Tomé e Príncipe',
        common: 'São Tomé e Príncipe'
      },
      rus: {
        official: 'Демократическая Республика Сан-Томе и Принсипи',
        common: 'Сан-Томе и Принсипи'
      },
      slk: {
        official: 'Demokratická republika Svätého Tomáša A princovho ostrova',
        common: 'Svätý Tomáš a Princov ostrov'
      },
      spa: {
        official: 'República Democrática de Santo Tomé y Príncipe',
        common: 'Santo Tomé y Príncipe'
      },
      swe: {
        official: 'Demokratiska republiken São Tomé och Príncipe',
        common: 'São Tomé och Príncipe'
      },
      tur: {
        official: 'São Tomé ve Príncipe Demokratik Cumhuriyeti',
        common: 'São Tomé ve Príncipe'
      },
      urd: {
        official: 'جمہوریہ ساؤ ٹومے و پرنسپے',
        common: 'ساؤ ٹومے و پرنسپے'
      },
      zho: {
        official: '圣多美和普林西比民主共和国',
        common: '圣多美和普林西比'
      }
    },
    latlng: [1.0, 7.0],
    landlocked: false,
    area: 964.0,
    demonyms: {
      eng: { f: 'Sao Tomean', m: 'Sao Tomean' },
      fra: { f: 'Santoméenne', m: 'Santoméen' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDF9',
    maps: {
      googleMaps: 'https://goo.gl/maps/9EUppm13RtPX9oF46',
      openStreetMaps: 'https://www.openstreetmap.org/relation/535880'
    },
    population: 219161,
    gini: { 2017: 56.3 },
    fifa: 'STP',
    car: { signs: ['STP'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/st.png',
      svg: 'https://flagcdn.com/st.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/st.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/st.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [0.34, 6.73] }
  },
  {
    name: {
      common: 'Togo',
      official: 'Togolese Republic',
      nativeName: { fra: { official: 'République togolaise', common: 'Togo' } }
    },
    tld: ['.tg'],
    cca2: 'TG',
    ccn3: '768',
    cca3: 'TGO',
    cioc: 'TOG',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XOF: { name: 'West African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['28'] },
    capital: ['Lomé'],
    altSpellings: [
      'TG',
      'Togolese',
      'Togolese Republic',
      'République Togolaise'
    ],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جمهورية توغو', common: 'توغو' },
      bre: { official: 'Republik Togoat', common: 'Togo' },
      ces: { official: 'Republika Togo', common: 'Togo' },
      cym: { official: 'Togolese Republic', common: 'Togo' },
      deu: { official: 'Republik Togo', common: 'Togo' },
      est: { official: 'Togo Vabariik', common: 'Togo' },
      fin: { official: 'Togon tasavalta', common: 'Togo' },
      fra: { official: 'République togolaise', common: 'Togo' },
      hrv: { official: 'Togolese Republika', common: 'Togo' },
      hun: { official: 'Togói Köztársaság', common: 'Togo' },
      ita: { official: 'Repubblica del Togo', common: 'Togo' },
      jpn: { official: 'トーゴ共和国', common: 'トーゴ' },
      kor: { official: '토고 공화국', common: '토고' },
      nld: { official: 'Republiek Togo', common: 'Togo' },
      per: { official: 'جمهوری توگو', common: 'توگو' },
      pol: { official: 'Republika Togijska', common: 'Togo' },
      por: { official: 'República do Togo', common: 'Togo' },
      rus: { official: 'Того Республика', common: 'Того' },
      slk: { official: 'Togská republika', common: 'Togo' },
      spa: { official: 'República de Togo', common: 'Togo' },
      swe: { official: 'Republiken Togo', common: 'Togo' },
      tur: { official: 'Togo Cumhuriyeti', common: 'Togo' },
      urd: { official: 'جمہوریہ ٹوگو', common: 'ٹوگو' },
      zho: { official: '多哥共和国', common: '多哥' }
    },
    latlng: [8.0, 1.16666666],
    landlocked: false,
    borders: ['BEN', 'BFA', 'GHA'],
    area: 56785.0,
    demonyms: {
      eng: { f: 'Togolese', m: 'Togolese' },
      fra: { f: 'Togolaise', m: 'Togolais' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/jzAa9feXuXPrKVb89',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192782'
    },
    population: 8278737,
    gini: { 2015: 43.1 },
    fifa: 'TOG',
    car: { signs: ['TG'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/tg.png',
      svg: 'https://flagcdn.com/tg.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tg.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tg.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [6.14, 1.21] }
  },
  {
    name: {
      common: 'DR Congo',
      official: 'Democratic Republic of the Congo',
      nativeName: {
        fra: {
          official: 'République démocratique du Congo',
          common: 'RD Congo'
        },
        kon: {
          official: 'Repubilika ya Kongo Demokratiki',
          common: 'Repubilika ya Kongo Demokratiki'
        },
        lin: {
          official: 'Republiki ya Kongó Demokratiki',
          common: 'Republiki ya Kongó Demokratiki'
        },
        lua: {
          official: 'Ditunga dia Kongu wa Mungalaata',
          common: 'Ditunga dia Kongu wa Mungalaata'
        },
        swa: {
          official: 'Jamhuri ya Kidemokrasia ya Kongo',
          common: 'Jamhuri ya Kidemokrasia ya Kongo'
        }
      }
    },
    tld: ['.cd'],
    cca2: 'CD',
    ccn3: '180',
    cca3: 'COD',
    cioc: 'COD',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { CDF: { name: 'Congolese franc', symbol: 'FC' } },
    idd: { root: '+2', suffixes: ['43'] },
    capital: ['Kinshasa'],
    altSpellings: [
      'CD',
      'DR Congo',
      'Congo-Kinshasa',
      'Congo, the Democratic Republic of the',
      'DRC'
    ],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: {
      fra: 'French',
      kon: 'Kikongo',
      lin: 'Lingala',
      lua: 'Tshiluba',
      swa: 'Swahili'
    },
    translations: {
      ara: { official: 'جمهورية الكونغو الديمقراطية', common: 'الكونغو' },
      bre: { official: 'Republik Demokratel Kongo', common: 'Kongo-Kinshasa' },
      ces: { official: 'Demokratická republika Kongo', common: 'DR Kongo' },
      cym: {
        official: 'Gweriniaeth Ddemocrataidd Congo',
        common: 'Gweriniaeth Ddemocrataidd Congo'
      },
      deu: {
        official: 'Demokratische Republik Kongo',
        common: 'Kongo (Dem. Rep.)'
      },
      est: { official: 'Kongo Demokraatlik Vabariik', common: 'Kongo DV' },
      fin: {
        official: 'Kongon demokraattinen tasavalta',
        common: 'Kongon demokraattinen tasavalta'
      },
      fra: {
        official: 'République démocratique du Congo',
        common: 'Congo (Rép. dém.)'
      },
      hrv: {
        official: 'Demokratska Republika Kongo',
        common: 'Kongo, Demokratska Republika'
      },
      hun: {
        official: 'Kongói Demokratikus Köztársaság',
        common: 'Kongói Demokratikus Köztársaság'
      },
      ita: {
        official: 'Repubblica Democratica del Congo',
        common: 'Congo (Rep. Dem.)'
      },
      jpn: { official: 'コンゴ民主共和国', common: 'コンゴ民主共和国' },
      kor: { official: '콩고 민주 공화국', common: '콩고 민주 공화국' },
      nld: { official: 'Democratische Republiek Congo', common: 'Congo (DRC)' },
      per: { official: 'جمهوری دموکراتیک کنگو', common: 'کنگو دموکراتیک' },
      pol: {
        official: 'Demokratyczna Republika Konga',
        common: 'Demokratyczna Republika Konga'
      },
      por: {
        official: 'República Democrática do Congo',
        common: 'República Democrática do Congo'
      },
      rus: {
        official: 'Демократическая Республика Конго',
        common: 'Демократическая Республика Конго'
      },
      slk: { official: 'Konžská demokratická republika', common: 'Kongo' },
      spa: {
        official: 'República Democrática del Congo',
        common: 'Congo (Rep. Dem.)'
      },
      swe: {
        official: 'Demokratiska republiken Kongo',
        common: 'Kongo-Kinshasa'
      },
      tur: {
        official: 'Kongo Demokratik Cumhuriyeti',
        common: 'Kongo Demokratik Cumhuriyeti'
      },
      urd: { official: 'جمہوری جمہوریہ کانگو', common: 'کانگو' },
      zho: { official: '刚果民主共和国', common: '民主刚果' }
    },
    latlng: [0.0, 25.0],
    landlocked: false,
    borders: ['AGO', 'BDI', 'CAF', 'COG', 'RWA', 'SSD', 'TZA', 'UGA', 'ZMB'],
    area: 2344858.0,
    demonyms: {
      eng: { f: 'Congolese', m: 'Congolese' },
      fra: { f: 'Congolaise', m: 'Congolais' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDE9',
    maps: {
      googleMaps: 'https://goo.gl/maps/KfhNVn6VqdZXWu8n9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192795'
    },
    population: 108407721,
    gini: { 2012: 42.1 },
    fifa: 'COD',
    car: { signs: ['CGO'], side: 'right' },
    timezones: ['UTC+01:00', 'UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/cd.png',
      svg: 'https://flagcdn.com/cd.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cd.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cd.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-4.32, 15.3] }
  },
  {
    name: {
      common: 'Chad',
      official: 'Republic of Chad',
      nativeName: {
        ara: { official: 'جمهورية تشاد', common: 'تشاد‎' },
        fra: { official: 'République du Tchad', common: 'Tchad' }
      }
    },
    tld: ['.td'],
    cca2: 'TD',
    ccn3: '148',
    cca3: 'TCD',
    cioc: 'CHA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XAF: { name: 'Central African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['35'] },
    capital: ["N'Djamena"],
    altSpellings: ['TD', 'Tchad', 'Republic of Chad', 'République du Tchad'],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { ara: 'Arabic', fra: 'French' },
    translations: {
      ara: { official: 'جمهورية تشاد', common: 'تشاد' },
      bre: { official: 'Republik Tchad', common: 'Tchad' },
      ces: { official: 'Čadská republika', common: 'Čad' },
      cym: { official: 'Gweriniaeth Tsiad', common: 'Tsiad' },
      deu: { official: 'Republik Tschad', common: 'Tschad' },
      est: { official: 'Tšaadi Vabariik', common: 'Tšaad' },
      fin: { official: 'Tšadin tasavalta', common: 'Tšad' },
      fra: { official: 'République du Tchad', common: 'Tchad' },
      hrv: { official: 'Čadu', common: 'Čad' },
      hun: { official: 'Csád Köztársaság', common: 'Csád' },
      ita: { official: 'Repubblica del Ciad', common: 'Ciad' },
      jpn: { official: 'チャド共和国', common: 'チャド' },
      kor: { official: '차드 공화국', common: '차드' },
      nld: { official: 'Republiek Tsjaad', common: 'Tsjaad' },
      per: { official: 'جمهوری چاد', common: 'چاد' },
      pol: { official: 'Republika Czadu', common: 'Czad' },
      por: { official: 'República do Chade', common: 'Chade' },
      rus: { official: 'Республика Чад', common: 'Чад' },
      slk: { official: 'Čadská republika', common: 'Čad' },
      spa: { official: 'República de Chad', common: 'Chad' },
      swe: { official: 'Republiken Tchad', common: 'Tchad' },
      tur: { official: 'Çad Cumhuriyeti', common: 'Çad' },
      urd: { official: 'جمہوریہ چاڈ', common: 'چاڈ' },
      zho: { official: '乍得共和国', common: '乍得' }
    },
    latlng: [15.0, 19.0],
    landlocked: true,
    borders: ['CMR', 'CAF', 'LBY', 'NER', 'NGA', 'SDN'],
    area: 1284000.0,
    demonyms: {
      eng: { f: 'Chadian', m: 'Chadian' },
      fra: { f: 'Tchadienne', m: 'Tchadien' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDE9',
    maps: {
      googleMaps: 'https://goo.gl/maps/ziUdAZ8skuNfx5Hx7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2361304'
    },
    population: 16425859,
    gini: { 2011: 43.3 },
    fifa: 'CHA',
    car: { signs: ['TCH', 'TD'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/td.png',
      svg: 'https://flagcdn.com/td.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/td.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/td.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [12.1, 15.03] }
  },
  {
    name: {
      common: 'Mozambique',
      official: 'Republic of Mozambique',
      nativeName: {
        por: { official: 'República de Moçambique', common: 'Moçambique' }
      }
    },
    tld: ['.mz'],
    cca2: 'MZ',
    ccn3: '508',
    cca3: 'MOZ',
    cioc: 'MOZ',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MZN: { name: 'Mozambican metical', symbol: 'MT' } },
    idd: { root: '+2', suffixes: ['58'] },
    capital: ['Maputo'],
    altSpellings: ['MZ', 'Republic of Mozambique', 'República de Moçambique'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { por: 'Portuguese' },
    translations: {
      ara: { official: 'جمهورية موزمبيق', common: 'موزمبيق' },
      bre: { official: 'Republik Mozambik', common: 'Mozambik' },
      ces: { official: 'Mosambická republika', common: 'Mosambik' },
      cym: { official: 'Republic of Mozambique', common: 'Mozambique' },
      deu: { official: 'Republik Mosambik', common: 'Mosambik' },
      est: { official: 'Mosambiigi Vabariik', common: 'Mosambiik' },
      fin: { official: 'Mosambikin tasavalta', common: 'Mosambik' },
      fra: { official: 'République du Mozambique', common: 'Mozambique' },
      hrv: { official: 'Republika Mozambiku', common: 'Mozambik' },
      hun: { official: 'Mozambiki Köztársaság', common: 'Mozambik' },
      ita: { official: 'Repubblica del Mozambico', common: 'Mozambico' },
      jpn: { official: 'モザンビーク共和国', common: 'モザンビーク' },
      kor: { official: '모잠비크 공화국', common: '모잠비크' },
      nld: { official: 'Republiek Mozambique', common: 'Mozambique' },
      per: { official: 'جمهوری موزامبیک', common: 'موزامبیک' },
      pol: { official: 'Republika Mozambiku', common: 'Mozambik' },
      por: { official: 'República de Moçambique', common: 'Moçambique' },
      rus: { official: 'Республика Мозамбик', common: 'Мозамбик' },
      slk: { official: 'Mozambická republika', common: 'Mozambik' },
      spa: { official: 'República de Mozambique', common: 'Mozambique' },
      swe: { official: 'Republiken Moçambique', common: 'Moçambique' },
      tur: { official: 'Mozambik Cumhuriyeti', common: 'Mozambik' },
      urd: { official: 'جمہوریہ موزمبیق', common: 'موزمبیق' },
      zho: { official: '莫桑比克共和国', common: '莫桑比克' }
    },
    latlng: [-18.25, 35.0],
    landlocked: false,
    borders: ['MWI', 'ZAF', 'SWZ', 'TZA', 'ZMB', 'ZWE'],
    area: 801590.0,
    demonyms: {
      eng: { f: 'Mozambican', m: 'Mozambican' },
      fra: { f: 'Mozambicaine', m: 'Mozambicain' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDFF',
    maps: {
      googleMaps: 'https://goo.gl/maps/xCLcY9fzU6x4Pueu5',
      openStreetMaps: 'https://www.openstreetmap.org/relation/195273'
    },
    population: 31255435,
    gini: { 2014: 54.0 },
    fifa: 'MOZ',
    car: { signs: ['MOC'], side: 'left' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/mz.png',
      svg: 'https://flagcdn.com/mz.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mz.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mz.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-25.95, 32.58] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Sierra Leone',
      official: 'Republic of Sierra Leone',
      nativeName: {
        eng: { official: 'Republic of Sierra Leone', common: 'Sierra Leone' }
      }
    },
    tld: ['.sl'],
    cca2: 'SL',
    ccn3: '694',
    cca3: 'SLE',
    cioc: 'SLE',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SLL: { name: 'Sierra Leonean leone', symbol: 'Le' } },
    idd: { root: '+2', suffixes: ['32'] },
    capital: ['Freetown'],
    altSpellings: ['SL', 'Republic of Sierra Leone'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية سيراليون', common: 'سيراليون' },
      bre: { official: 'Republik Sierra Leone', common: 'Sierra Leone' },
      ces: { official: 'Republika Sierra Leone', common: 'Sierra Leone' },
      cym: { official: 'Republic of Sierra Leone', common: 'Sierra Leone' },
      deu: { official: 'Republik Sierra Leone', common: 'Sierra Leone' },
      est: { official: 'Sierra Leone Vabariik', common: 'Sierra Leone' },
      fin: { official: 'Sierra Leonen tasavalta', common: 'Sierra Leone' },
      fra: { official: 'République de Sierra Leone', common: 'Sierra Leone' },
      hrv: { official: 'Republika Sijera Leone', common: 'Sijera Leone' },
      hun: { official: 'Sierra Leone Köztársaság', common: 'Sierra Leone' },
      ita: {
        official: 'Repubblica della Sierra Leone',
        common: 'Sierra Leone'
      },
      jpn: { official: 'シエラレオネ共和国', common: 'シエラレオネ' },
      kor: { official: '시에라리온 공화국', common: '시에라리온' },
      nld: { official: 'Republiek Sierra Leone', common: 'Sierra Leone' },
      per: { official: 'جمهوری سیرالئون', common: 'سیرالئون' },
      pol: { official: 'Sierra Leone', common: 'Sierra Leone' },
      por: { official: 'República da Serra Leoa', common: 'Serra Leoa' },
      rus: { official: 'Республика Сьерра-Леоне', common: 'Сьерра-Леоне' },
      slk: { official: 'Sierraleonská republika', common: 'Sierra Leone' },
      spa: { official: 'República de Sierra Leona', common: 'Sierra Leone' },
      swe: { official: 'Republiken Sierra Leone', common: 'Sierra Leone' },
      tur: { official: 'Sierra Leone Cumhuriyeti', common: 'Sierra Leone' },
      urd: { official: 'جمہوریہ سیرالیون', common: 'سیرالیون' },
      zho: { official: '塞拉利昂共和国', common: '塞拉利昂' }
    },
    latlng: [8.5, -11.5],
    landlocked: false,
    borders: ['GIN', 'LBR'],
    area: 71740.0,
    demonyms: {
      eng: { f: 'Sierra Leonean', m: 'Sierra Leonean' },
      fra: { f: 'Sierra-leonaise', m: 'Sierra-leonais' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDF1',
    maps: {
      googleMaps: 'https://goo.gl/maps/jhacar85oq9QaeKB7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192777'
    },
    population: 7976985,
    gini: { 2018: 35.7 },
    fifa: 'SLE',
    car: { signs: ['WAL'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/sl.png',
      svg: 'https://flagcdn.com/sl.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sl.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sl.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [8.48, -13.23] }
  },
  {
    name: {
      common: 'Central African Republic',
      official: 'Central African Republic',
      nativeName: {
        fra: {
          official: 'République centrafricaine',
          common: 'République centrafricaine'
        },
        sag: { official: 'Ködörösêse tî Bêafrîka', common: 'Bêafrîka' }
      }
    },
    tld: ['.cf'],
    cca2: 'CF',
    ccn3: '140',
    cca3: 'CAF',
    cioc: 'CAF',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XAF: { name: 'Central African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['36'] },
    capital: ['Bangui'],
    altSpellings: [
      'CF',
      'Central African Republic',
      'République centrafricaine'
    ],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { fra: 'French', sag: 'Sango' },
    translations: {
      ara: {
        official: 'جمهورية أفريقيا الوسطى',
        common: 'جمهورية أفريقيا الوسطى'
      },
      bre: {
        official: 'Republik Kreizafrikan',
        common: 'Republik Kreizafrikan'
      },
      ces: {
        official: 'Středoafrická republika',
        common: 'Středoafrická republika'
      },
      cym: {
        official: 'Gweriniaeth Canolbarth Affrica',
        common: 'Gweriniaeth Canolbarth Affrica'
      },
      deu: {
        official: 'Zentralafrikanische Republik',
        common: 'Zentralafrikanische Republik'
      },
      est: {
        official: 'Kesk-Aafrika Vabariik',
        common: 'Kesk-Aafrika Vabariik'
      },
      fin: {
        official: 'Keski-Afrikan tasavalta',
        common: 'Keski-Afrikan tasavalta'
      },
      fra: {
        official: 'République centrafricaine',
        common: 'République centrafricaine'
      },
      hrv: {
        official: 'Centralna Afrička Republika',
        common: 'Srednjoafrička Republika'
      },
      hun: {
        official: 'Közép-afrikai Köztársaság',
        common: 'Közép-afrikai Köztársaság'
      },
      ita: {
        official: 'Repubblica Centrafricana',
        common: 'Repubblica Centrafricana'
      },
      jpn: { official: '中央アフリカ共和国', common: '中央アフリカ共和国' },
      kor: { official: '중앙아프리카 공화국', common: '중앙아프리카 공화국' },
      nld: {
        official: 'Centraal-Afrikaanse Republiek',
        common: 'Centraal-Afrikaanse Republiek'
      },
      per: { official: 'جمهوری آفریقای مرکزی', common: 'جمهوری آفریقای مرکزی' },
      pol: {
        official: 'Republika Środkowoafrykańska',
        common: 'Republika Środkowoafrykańska'
      },
      por: {
        official: 'República Centro-Africano',
        common: 'República Centro-Africana'
      },
      rus: {
        official: 'Центрально-Африканская Республика',
        common: 'Центральноафриканская Республика'
      },
      slk: {
        official: 'Stredoafrická republika',
        common: 'Stredoafrická republika'
      },
      spa: {
        official: 'República Centroafricana',
        common: 'República Centroafricana'
      },
      swe: {
        official: 'Centralafrikanska republiken',
        common: 'Centralafrikanska republiken'
      },
      tur: {
        official: 'Orta Afrika Cumhuriyeti',
        common: 'Orta Afrika Cumhuriyeti'
      },
      urd: { official: 'وسطی افریقی جمہوریہ', common: 'وسطی افریقی جمہوریہ' },
      zho: { official: '中非共和国', common: '中非共和国' }
    },
    latlng: [7.0, 21.0],
    landlocked: true,
    borders: ['CMR', 'TCD', 'COD', 'COG', 'SSD', 'SDN'],
    area: 622984.0,
    demonyms: {
      eng: { f: 'Central African', m: 'Central African' },
      fra: { f: 'Centrafricaine', m: 'Centrafricain' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDEB',
    maps: {
      googleMaps: 'https://goo.gl/maps/51V8dsi2rGYC9n3c9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192790'
    },
    population: 4829764,
    gini: { 2008: 56.2 },
    fifa: 'CTA',
    car: { signs: ['RCA'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/cf.png',
      svg: 'https://flagcdn.com/cf.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cf.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cf.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [4.37, 18.58] }
  },
  {
    name: {
      common: 'Gabon',
      official: 'Gabonese Republic',
      nativeName: { fra: { official: 'République gabonaise', common: 'Gabon' } }
    },
    tld: ['.ga'],
    cca2: 'GA',
    ccn3: '266',
    cca3: 'GAB',
    cioc: 'GAB',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XAF: { name: 'Central African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['41'] },
    capital: ['Libreville'],
    altSpellings: ['GA', 'Gabonese Republic', 'République Gabonaise'],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جمهورية الغابون', common: 'الغابون' },
      bre: { official: 'Republik Gabonat', common: 'Gabon' },
      ces: { official: 'Gabonská republika', common: 'Gabon' },
      cym: { official: 'Gabonese Republic', common: 'Gabon' },
      deu: { official: 'Gabunische Republik', common: 'Gabun' },
      est: { official: 'Gaboni Vabariik', common: 'Gabon' },
      fin: { official: 'Gabonin tasavalta', common: 'Gabon' },
      fra: { official: 'République gabonaise', common: 'Gabon' },
      hrv: { official: 'Gabon Republika', common: 'Gabon' },
      hun: { official: 'Gaboni Köztársaság', common: 'Gabon' },
      ita: { official: 'Repubblica gabonese', common: 'Gabon' },
      jpn: { official: 'ガボン共和国', common: 'ガボン' },
      kor: { official: '가봉 공화국', common: '가봉' },
      nld: { official: 'Republiek Gabon', common: 'Gabon' },
      per: { official: 'جمهوری گابُن', common: 'گابن' },
      pol: { official: 'Republika Gabońska', common: 'Gabon' },
      por: { official: 'República do Gabão', common: 'Gabão' },
      rus: { official: 'Габона Республика', common: 'Габон' },
      slk: { official: 'Gabonská republika', common: 'Gabon' },
      spa: { official: 'República de Gabón', common: 'Gabón' },
      swe: { official: 'Republiken Gabon', common: 'Gabon' },
      tur: { official: 'Gabon Cumhuriyeti', common: 'Gabon' },
      urd: { official: 'جمہوریہ گیبون', common: 'گیبون' },
      zho: { official: '加蓬共和国', common: '加蓬' }
    },
    latlng: [-1.0, 11.75],
    landlocked: false,
    borders: ['CMR', 'COG', 'GNQ'],
    area: 267668.0,
    demonyms: {
      eng: { f: 'Gabonese', m: 'Gabonese' },
      fra: { f: 'Gabonaise', m: 'Gabonais' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://www.openstreetmap.org/relation/192793',
      openStreetMaps: 'https://goo.gl/maps/vyRSkqw1H1fnq4ry6'
    },
    population: 2225728,
    gini: { 2017: 38.0 },
    fifa: 'GAB',
    car: { signs: ['G'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ga.png',
      svg: 'https://flagcdn.com/ga.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ga.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ga.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [0.38, 9.45] }
  },
  {
    name: {
      common: 'Western Sahara',
      official: 'Sahrawi Arab Democratic Republic',
      nativeName: {
        ber: {
          official: 'Sahrawi Arab Democratic Republic',
          common: 'Western Sahara'
        },
        mey: {
          official: 'الجمهورية العربية الصحراوية الديمقراطية',
          common: 'الصحراء الغربية'
        },
        spa: {
          official: 'República Árabe Saharaui Democrática',
          common: 'Sahara Occidental'
        }
      }
    },
    tld: ['.eh'],
    cca2: 'EH',
    ccn3: '732',
    cca3: 'ESH',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: {
      DZD: { name: 'Algerian dinar', symbol: 'دج' },
      MAD: { name: 'Moroccan dirham', symbol: 'DH' },
      MRU: { name: 'Mauritanian ouguiya', symbol: 'UM' }
    },
    idd: { root: '+2', suffixes: ['125288', '125289'] },
    capital: ['El Aaiún'],
    altSpellings: ['EH', 'Taneẓroft Tutrimt'],
    region: 'Africa',
    subregion: 'Northern Africa',
    languages: { ber: 'Berber', mey: 'Hassaniya', spa: 'Spanish' },
    translations: {
      ara: {
        official: 'الجمهورية العربية الصحراوية الديمقراطية',
        common: 'الصحراء الغربية'
      },
      bre: {
        official: 'Republik Arab Saharaoui Demokratel',
        common: "Sahara ar C'hornôg"
      },
      ces: { official: 'Západní Sahara', common: 'Západní Sahara' },
      cym: {
        official: 'Sahrawi Arab Democratic Republic',
        common: 'Western Sahara'
      },
      deu: {
        official: 'Demokratische Arabische Republik Sahara',
        common: 'Westsahara'
      },
      est: { official: 'Lääne-Sahara', common: 'Lääne-Sahara' },
      fin: { official: 'Länsi-Sahara', common: 'Länsi-Sahara' },
      fra: {
        official: 'République arabe sahraouie démocratique',
        common: 'Sahara Occidental'
      },
      hrv: {
        official: 'Sahrawi Arab Demokratska Republika',
        common: 'Zapadna Sahara'
      },
      hun: { official: 'Nyugat-Szahara', common: 'Nyugat-Szahara' },
      ita: {
        official: 'Repubblica Araba Saharawi Democratica',
        common: 'Sahara Occidentale'
      },
      jpn: { official: 'サハラアラブ民主共和国', common: '西サハラ' },
      kor: { official: '사하라 아랍 민주 공화국', common: '서사하라' },
      nld: {
        official: 'Sahrawi Arabische Democratische Republiek',
        common: 'Westelijke Sahara'
      },
      per: { official: 'صحرای غربی', common: 'صحرای غربی' },
      pol: {
        official: 'Saharyjska Arabska Republika Demokratyczna',
        common: 'Sahara Zachodnia'
      },
      por: {
        official: 'República Árabe Saharaui Democrática',
        common: 'Saara Ocidental'
      },
      rus: {
        official: 'Sahrawi Арабская Демократическая Республика',
        common: 'Западная Сахара'
      },
      slk: { official: 'Západná Sahara', common: 'Západná Sahara' },
      spa: {
        official: 'República Árabe Saharaui Democrática',
        common: 'Sahara Occidental'
      },
      swe: { official: 'Västsahara', common: 'Västsahara' },
      tur: {
        official: 'Sahra Demokratik Arap Cumhuriyeti',
        common: 'Sahra Demokratik Arap Cumhuriyeti'
      },
      urd: { official: 'صحراوی عرب عوامی جمہوریہ', common: 'مغربی صحارا' },
      zho: { official: '阿拉伯撒哈拉民主共和国', common: '西撒哈拉' }
    },
    latlng: [24.5, -13.0],
    landlocked: false,
    borders: ['DZA', 'MRT', 'MAR'],
    area: 266000.0,
    demonyms: { eng: { f: 'Sahrawi', m: 'Sahrawi' } },
    flag: '\uD83C\uDDEA\uD83C\uDDED',
    maps: {
      googleMaps: 'https://goo.gl/maps/7nU3mB69vP6zQp7A8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/5441968'
    },
    population: 510713,
    car: { signs: [''], side: 'right' },
    timezones: ['UTC+00:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/eh.png',
      svg: 'https://flagcdn.com/eh.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-13.28, 27.14] }
  },
  {
    name: {
      common: 'Angola',
      official: 'Republic of Angola',
      nativeName: { por: { official: 'República de Angola', common: 'Angola' } }
    },
    tld: ['.ao'],
    cca2: 'AO',
    ccn3: '024',
    cca3: 'AGO',
    cioc: 'ANG',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { AOA: { name: 'Angolan kwanza', symbol: 'Kz' } },
    idd: { root: '+2', suffixes: ['44'] },
    capital: ['Luanda'],
    altSpellings: ['AO', 'República de Angola', "ʁɛpublika de an'ɡɔla"],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { por: 'Portuguese' },
    translations: {
      ara: { official: 'أنغولا', common: 'جمهورية أنغولا' },
      bre: { official: 'Republik Angola', common: 'Angola' },
      ces: { official: 'Angolská republika', common: 'Angola' },
      cym: { official: 'Gweriniaeth Angola', common: 'Angola' },
      deu: { official: 'Republik Angola', common: 'Angola' },
      est: { official: 'Angola Vabariik', common: 'Angola' },
      fin: { official: 'Angolan tasavalta', common: 'Angola' },
      fra: { official: "République d'Angola", common: 'Angola' },
      hrv: { official: 'Republika Angola', common: 'Angola' },
      hun: { official: 'Angola', common: 'Angola' },
      ita: { official: "Repubblica dell'Angola", common: 'Angola' },
      jpn: { official: 'アンゴラ共和国', common: 'アンゴラ' },
      kor: { official: '앙골라 공화국', common: '앙골라' },
      nld: { official: 'Republiek Angola', common: 'Angola' },
      per: { official: 'جمهوری آنگولا', common: 'آنگولا' },
      pol: { official: 'Republika Angoli', common: 'Angola' },
      por: { official: 'República de Angola', common: 'Angola' },
      rus: { official: 'Республика Ангола', common: 'Ангола' },
      slk: { official: 'Angolská republika', common: 'Angola' },
      spa: { official: 'República de Angola', common: 'Angola' },
      swe: { official: 'Republiken Angola', common: 'Angola' },
      tur: { official: 'Angola Cumhuriyeti', common: 'Angola' },
      urd: { official: 'جمہوریہ انگولہ', common: 'انگولہ' },
      zho: { official: '安哥拉共和国', common: '安哥拉' }
    },
    latlng: [-12.5, 18.5],
    landlocked: false,
    borders: ['COG', 'COD', 'ZMB', 'NAM'],
    area: 1246700.0,
    demonyms: {
      eng: { f: 'Angolan', m: 'Angolan' },
      fra: { f: 'Angolaise', m: 'Angolais' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDF4',
    maps: {
      googleMaps: 'https://goo.gl/maps/q42Qbf1BmQL3fuZg9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/195267'
    },
    population: 32866268,
    gini: { 2018: 51.3 },
    fifa: 'ANG',
    car: { signs: ['ANG'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ao.png',
      svg: 'https://flagcdn.com/ao.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ao.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ao.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-8.83, 13.22] }
  },
  {
    name: {
      common: 'Tunisia',
      official: 'Tunisian Republic',
      nativeName: { ara: { official: 'الجمهورية التونسية', common: 'تونس' } }
    },
    tld: ['.tn'],
    cca2: 'TN',
    ccn3: '788',
    cca3: 'TUN',
    cioc: 'TUN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { TND: { name: 'Tunisian dinar', symbol: 'د.ت' } },
    idd: { root: '+2', suffixes: ['16'] },
    capital: ['Tunis'],
    altSpellings: ['TN', 'Republic of Tunisia', 'al-Jumhūriyyah at-Tūnisiyyah'],
    region: 'Africa',
    subregion: 'Northern Africa',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'الجمهورية التونسية', common: 'تونس' },
      bre: { official: 'Republik Tunizian', common: 'Tunizia' },
      ces: { official: 'Tuniská republika', common: 'Tunisko' },
      cym: { official: 'Tunisian Republic', common: 'Tunisia' },
      deu: { official: 'Tunesische Republik', common: 'Tunesien' },
      est: { official: 'Tuneesia Vabariik', common: 'Tuneesia' },
      fin: { official: 'Tunisian tasavalta', common: 'Tunisia' },
      fra: { official: 'République tunisienne', common: 'Tunisie' },
      hrv: { official: 'Tuniski Republika', common: 'Tunis' },
      hun: { official: 'Tunéziai Köztársaság', common: 'Tunézia' },
      ita: { official: 'Repubblica tunisina', common: 'Tunisia' },
      jpn: { official: 'チュニジア共和国', common: 'チュニジア' },
      kor: { official: '튀니지 공화국', common: '튀니지' },
      nld: { official: 'Republiek Tunesië', common: 'Tunesië' },
      per: { official: 'جمهوری تونس', common: 'تونس' },
      pol: { official: 'Republika Tunezyjska', common: 'Tunezja' },
      por: { official: 'República da Tunísia', common: 'Tunísia' },
      rus: { official: 'Тунисской Республики', common: 'Тунис' },
      slk: { official: 'Tuniská republika', common: 'Tunisko' },
      spa: { official: 'República de Túnez', common: 'Túnez' },
      swe: { official: 'Republiken Tunisien', common: 'Tunisien' },
      tur: { official: 'Tunus Cumhuriyeti', common: 'Tunus' },
      urd: { official: 'جمہوریہ تونس', common: 'تونس' },
      zho: { official: '突尼斯共和国', common: '突尼斯' }
    },
    latlng: [34.0, 9.0],
    landlocked: false,
    borders: ['DZA', 'LBY'],
    area: 163610.0,
    demonyms: {
      eng: { f: 'Tunisian', m: 'Tunisian' },
      fra: { f: 'Tunisienne', m: 'Tunisien' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/KgUmpZdUuNRaougs8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192757'
    },
    population: 11818618,
    gini: { 2015: 32.8 },
    fifa: 'TUN',
    car: { signs: ['TN'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/tn.png',
      svg: 'https://flagcdn.com/tn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [36.8, 10.18] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Mayotte',
      official: 'Department of Mayotte',
      nativeName: {
        fra: { official: 'Département de Mayotte', common: 'Mayotte' }
      }
    },
    tld: ['.yt'],
    cca2: 'YT',
    ccn3: '175',
    cca3: 'MYT',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+2', suffixes: ['62'] },
    capital: ['Mamoudzou'],
    altSpellings: ['YT', 'Department of Mayotte', 'Département de Mayotte'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'مايوت', common: 'مايوت' },
      bre: { official: 'Departamant Mayotte', common: 'Mayotte' },
      ces: { official: 'Mayotte', common: 'Mayotte' },
      cym: { official: 'Department of Mayotte', common: 'Mayotte' },
      deu: { official: 'Übersee-Département Mayotte', common: 'Mayotte' },
      est: { official: 'Mayotte', common: 'Mayotte' },
      fin: { official: 'Mayotte', common: 'Mayotte' },
      fra: { official: 'Département de Mayotte', common: 'Mayotte' },
      hrv: { official: 'Odjel Mayotte', common: 'Mayotte' },
      hun: { official: 'Mayotte', common: 'Mayotte' },
      ita: { official: 'Dipartimento di Mayotte', common: 'Mayotte' },
      jpn: { official: 'マヨット科', common: 'マヨット' },
      kor: { official: '마요트', common: '마요트' },
      nld: { official: 'Afdeling Mayotte', common: 'Mayotte' },
      per: { official: 'مجموعه شهرستانی مایوت', common: 'مایوت' },
      pol: { official: 'Majotta', common: 'Majotta' },
      por: { official: 'Departamento de Mayotte', common: 'Mayotte' },
      rus: { official: 'Департамент Майотта', common: 'Майотта' },
      slk: { official: 'Department Mayotte', common: 'Mayotte' },
      spa: { official: 'Departamento de Mayotte', common: 'Mayotte' },
      swe: { official: 'Departementsområdet Mayotte', common: 'Mayotte' },
      tur: { official: 'Mayotte', common: 'Mayotte' },
      urd: { official: 'مایوٹ', common: 'مایوٹ' },
      zho: { official: '马约特', common: '马约特' }
    },
    latlng: [-12.83333333, 45.16666666],
    landlocked: false,
    area: 374.0,
    demonyms: {
      eng: { f: 'Mahoran', m: 'Mahoran' },
      fra: { f: 'Mahoraise', m: 'Mahorais' }
    },
    flag: '\uD83C\uDDFE\uD83C\uDDF9',
    maps: {
      googleMaps: 'https://goo.gl/maps/1e7MXmfBwQv3TQGF7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1259885'
    },
    population: 226915,
    car: { signs: ['F'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/yt.png',
      svg: 'https://flagcdn.com/yt.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-12.78, 45.22] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'South Africa',
      official: 'Republic of South Africa',
      nativeName: {
        afr: { official: 'Republiek van Suid-Afrika', common: 'South Africa' },
        eng: { official: 'Republic of South Africa', common: 'South Africa' },
        nbl: {
          official: 'IRiphabliki yeSewula Afrika',
          common: 'Sewula Afrika'
        },
        nso: {
          official: 'Rephaboliki ya Afrika-Borwa ',
          common: 'Afrika-Borwa'
        },
        sot: {
          official: 'Rephaboliki ya Afrika Borwa',
          common: 'Afrika Borwa'
        },
        ssw: {
          official: 'IRiphabhulikhi yeNingizimu Afrika',
          common: 'Ningizimu Afrika'
        },
        tsn: {
          official: 'Rephaboliki ya Aforika Borwa',
          common: 'Aforika Borwa'
        },
        tso: {
          official: 'Riphabliki ra Afrika Dzonga',
          common: 'Afrika Dzonga'
        },
        ven: {
          official: 'Riphabuḽiki ya Afurika Tshipembe',
          common: 'Afurika Tshipembe'
        },
        xho: {
          official: 'IRiphabliki yaseMzantsi Afrika',
          common: 'Mzantsi Afrika'
        },
        zul: {
          official: 'IRiphabliki yaseNingizimu Afrika',
          common: 'Ningizimu Afrika'
        }
      }
    },
    tld: ['.za'],
    cca2: 'ZA',
    ccn3: '710',
    cca3: 'ZAF',
    cioc: 'RSA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { ZAR: { name: 'South African rand', symbol: 'R' } },
    idd: { root: '+2', suffixes: ['7'] },
    capital: ['Pretoria', 'Bloemfontein', 'Cape Town'],
    altSpellings: ['ZA', 'RSA', 'Suid-Afrika', 'Republic of South Africa'],
    region: 'Africa',
    subregion: 'Southern Africa',
    languages: {
      afr: 'Afrikaans',
      eng: 'English',
      nbl: 'Southern Ndebele',
      nso: 'Northern Sotho',
      sot: 'Southern Sotho',
      ssw: 'Swazi',
      tsn: 'Tswana',
      tso: 'Tsonga',
      ven: 'Venda',
      xho: 'Xhosa',
      zul: 'Zulu'
    },
    translations: {
      ara: { official: 'جمهورية جنوب أفريقيا', common: 'جنوب أفريقيا' },
      bre: { official: 'Republik Suafrika', common: 'Suafrika' },
      ces: {
        official: 'Jihoafrická republika',
        common: 'Jihoafrická republika'
      },
      cym: { official: 'Republic of South Africa', common: 'South Africa' },
      deu: { official: 'Republik Südafrika', common: 'Südafrika' },
      est: {
        official: 'Lõuna-Aafrika Vabariik',
        common: 'Lõuna-Aafrika Vabariik'
      },
      fin: { official: 'Etelä-Afrikan tasavalta', common: 'Etelä-Afrikka' },
      fra: {
        official: "République d'Afrique du Sud",
        common: 'Afrique du Sud'
      },
      hrv: {
        official: 'Južnoafrička Republika',
        common: 'Južnoafrička Republika'
      },
      hun: {
        official: 'Dél-afrikai Köztársaság',
        common: 'Dél-afrikai Köztársaság'
      },
      ita: { official: 'Repubblica del Sud Africa', common: 'Sud Africa' },
      jpn: { official: '南アフリカ共和国', common: '南アフリカ' },
      kor: { official: '남아프리카 공화국', common: '남아프리카' },
      nld: { official: 'Republiek Zuid-Afrika', common: 'Zuid-Afrika' },
      per: { official: 'جمهوری آفریقای جنوبی', common: 'آفریقای جنوبی' },
      pol: {
        official: 'Republika Południowej Afryki',
        common: 'Południowa Afryka'
      },
      por: { official: 'República da África do Sul', common: 'África do Sul' },
      rus: {
        official: 'Южно-Африканская Республика',
        common: 'Южно-Африканская Республика'
      },
      slk: {
        official: 'Juhoafrická republika',
        common: 'Juhoafrická republika'
      },
      spa: {
        official: 'República de Sudáfrica',
        common: 'República de Sudáfrica'
      },
      swe: { official: 'Republiken Sydafrika', common: 'Sydafrika' },
      tur: { official: 'Güney Afrika Cumhuriyeti', common: 'Güney Afrika' },
      urd: { official: 'جمہوریہ جنوبی افریقا', common: 'جنوبی افریقا' },
      zho: { official: '南非共和国', common: '南非' }
    },
    latlng: [-29.0, 24.0],
    landlocked: false,
    borders: ['BWA', 'LSO', 'MOZ', 'NAM', 'SWZ', 'ZWE'],
    area: 1221037.0,
    demonyms: {
      eng: { f: 'South African', m: 'South African' },
      fra: { f: 'Sud-africaine', m: 'Sud-africain' }
    },
    flag: '\uD83C\uDDFF\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://goo.gl/maps/CLCZ1R8Uz1KpYhRv6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/87565'
    },
    population: 59308690,
    gini: { 2014: 63.0 },
    fifa: 'RSA',
    car: { signs: ['ZA'], side: 'left' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/za.png',
      svg: 'https://flagcdn.com/za.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/za.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/za.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-25.7, 28.22] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Nigeria',
      official: 'Federal Republic of Nigeria',
      nativeName: {
        eng: { official: 'Federal Republic of Nigeria', common: 'Nigeria' }
      }
    },
    tld: ['.ng'],
    cca2: 'NG',
    ccn3: '566',
    cca3: 'NGA',
    cioc: 'NGR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { NGN: { name: 'Nigerian naira', symbol: '₦' } },
    idd: { root: '+2', suffixes: ['34'] },
    capital: ['Abuja'],
    altSpellings: ['NG', 'Nijeriya', 'Naíjíríà', 'Federal Republic of Nigeria'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية نيجيريا الاتحادية', common: 'نيجيريا' },
      bre: { official: 'Republik Kevreadel Nigeria', common: 'Nigeria' },
      ces: { official: 'Nigerijská federativní republika', common: 'Nigérie' },
      cym: { official: 'Federal Republic of Nigeria', common: 'Nigeria' },
      deu: { official: 'Bundesrepublik Nigeria', common: 'Nigeria' },
      est: { official: 'Nigeeria Liitvabariik', common: 'Nigeeria' },
      fin: { official: 'Nigerian liittotasavalta', common: 'Nigeria' },
      fra: { official: 'République fédérale du Nigeria', common: 'Nigéria' },
      hrv: { official: 'Savezna Republika Nigerija', common: 'Nigerija' },
      hun: { official: 'Nigéria', common: 'Nigéria' },
      ita: { official: 'Repubblica federale di Nigeria', common: 'Nigeria' },
      jpn: { official: 'ナイジェリア連邦共和国', common: 'ナイジェリア' },
      kor: { official: '나이지리아 연방 공화국', common: '나이지리아' },
      nld: { official: 'Federale Republiek Nigeria', common: 'Nigeria' },
      per: { official: 'جمهوری فدرال نیجریه', common: 'نیجریه' },
      pol: { official: 'Federalna Republika Nigerii', common: 'Nigeria' },
      por: { official: 'República Federal da Nigéria', common: 'Nigéria' },
      rus: { official: 'Федеративная Республика Нигерия', common: 'Нигерия' },
      slk: { official: 'Nigérijská federatívna republika', common: 'Nigéria' },
      spa: { official: 'República Federal de Nigeria', common: 'Nigeria' },
      swe: { official: 'Förbundsrepubliken Nigeria', common: 'Nigeria' },
      tur: { official: 'Nijerya Federal Cumhuriyeti', common: 'Nijerya' },
      urd: { official: 'وفاقی جمہوریہ نائجیریا', common: 'نائجیریا' },
      zho: { official: '尼日利亚联邦共和国', common: '尼日利亚' }
    },
    latlng: [10.0, 8.0],
    landlocked: false,
    borders: ['BEN', 'CMR', 'TCD', 'NER'],
    area: 923768.0,
    demonyms: {
      eng: { f: 'Nigerian', m: 'Nigerian' },
      fra: { f: 'Nigériane', m: 'Nigérian' }
    },
    flag: '\uD83C\uDDF3\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/LTn417qWwBPFszuV9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192787'
    },
    population: 206139587,
    gini: { 2018: 35.1 },
    fifa: 'NGA',
    car: { signs: ['WAN'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ng.png',
      svg: 'https://flagcdn.com/ng.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ng.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ng.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [9.08, 7.53] },
    postalCode: { format: '######', regex: '^(\\d{6})$' }
  },
  {
    name: {
      common: 'Malawi',
      official: 'Republic of Malawi',
      nativeName: {
        eng: { official: 'Republic of Malawi', common: 'Malawi' },
        nya: { official: 'Chalo cha Malawi, Dziko la Malaŵi', common: 'Malaŵi' }
      }
    },
    tld: ['.mw'],
    cca2: 'MW',
    ccn3: '454',
    cca3: 'MWI',
    cioc: 'MAW',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MWK: { name: 'Malawian kwacha', symbol: 'MK' } },
    idd: { root: '+2', suffixes: ['65'] },
    capital: ['Lilongwe'],
    altSpellings: ['MW', 'Republic of Malawi'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { eng: 'English', nya: 'Chewa' },
    translations: {
      ara: { official: 'جمهورية مالاوي', common: 'مالاوي' },
      bre: { official: 'Republik Malawi', common: 'Malawi' },
      ces: { official: 'Malawiská republika', common: 'Malawi' },
      cym: { official: 'Republic of Malawi', common: 'Malawi' },
      deu: { official: 'Republik Malawi', common: 'Malawi' },
      est: { official: 'Malawi Vabariik', common: 'Malawi' },
      fin: { official: 'Malawin tasavalta', common: 'Malawi' },
      fra: { official: 'République du Malawi', common: 'Malawi' },
      hrv: { official: 'Republika Malavi', common: 'Malavi' },
      hun: { official: 'Malawi Köztársaság', common: 'Malawi' },
      ita: { official: 'Repubblica del Malawi', common: 'Malawi' },
      jpn: { official: 'マラウイ共和国', common: 'マラウイ' },
      kor: { official: '말라위 공화국', common: '말라위' },
      nld: { official: 'Republiek Malawi', common: 'Malawi' },
      per: { official: 'جمهوری مالاوی', common: 'مالاوی' },
      pol: { official: 'Republika Malawi', common: 'Malawi' },
      por: { official: 'República do Malawi', common: 'Malawi' },
      rus: { official: 'Республика Малави', common: 'Малави' },
      slk: { official: 'Malawijská republika', common: 'Malawi' },
      spa: { official: 'República de Malawi', common: 'Malawi' },
      swe: { official: 'Republiken Malawi', common: 'Malawi' },
      tur: { official: 'Malavi Cumhuriyeti', common: 'Malavi' },
      urd: { official: 'جمہوریہ ملاوی', common: 'ملاوی' },
      zho: { official: '马拉维共和国', common: '马拉维' }
    },
    latlng: [-13.5, 34.0],
    landlocked: true,
    borders: ['MOZ', 'TZA', 'ZMB'],
    area: 118484.0,
    demonyms: {
      eng: { f: 'Malawian', m: 'Malawian' },
      fra: { f: 'Malawienne', m: 'Malawien' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/mc6z83pW9m98X2Ef6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/195290'
    },
    population: 19129955,
    gini: { 2016: 44.7 },
    fifa: 'MWI',
    car: { signs: ['MW'], side: 'left' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/mw.png',
      svg: 'https://flagcdn.com/mw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mw.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-13.97, 33.78] }
  },
  {
    name: {
      common: 'Mauritania',
      official: 'Islamic Republic of Mauritania',
      nativeName: {
        ara: {
          official: 'الجمهورية الإسلامية الموريتانية',
          common: 'موريتانيا'
        }
      }
    },
    tld: ['.mr'],
    cca2: 'MR',
    ccn3: '478',
    cca3: 'MRT',
    cioc: 'MTN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MRU: { name: 'Mauritanian ouguiya', symbol: 'UM' } },
    idd: { root: '+2', suffixes: ['22'] },
    capital: ['Nouakchott'],
    altSpellings: [
      'MR',
      'Islamic Republic of Mauritania',
      'al-Jumhūriyyah al-ʾIslāmiyyah al-Mūrītāniyyah'
    ],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'الجمهورية الإسلامية الموريتانية', common: 'موريتانيا' },
      bre: { official: 'Republik islamek Maouritania', common: 'Maouritania' },
      ces: { official: 'Mauritánská islámská republika', common: 'Mauritánie' },
      cym: { official: 'Islamic Republic of Mauritania', common: 'Mauritania' },
      deu: {
        official: 'Islamische Republik Mauretanien',
        common: 'Mauretanien'
      },
      est: { official: 'Mauritaania Islamivabariik', common: 'Mauritaania' },
      fin: {
        official: 'Mauritanian islamilainen tasavalta',
        common: 'Mauritania'
      },
      fra: {
        official: 'République islamique de Mauritanie',
        common: 'Mauritanie'
      },
      hrv: {
        official: 'Islamska Republika Mauritanija',
        common: 'Mauritanija'
      },
      hun: { official: 'Mauritániai Iszlám Köztársaság', common: 'Mauritánia' },
      ita: {
        official: 'Repubblica islamica di Mauritania',
        common: 'Mauritania'
      },
      jpn: { official: 'モーリタニア·イスラム共和国', common: 'モーリタニア' },
      kor: { official: '모리타니 이슬람 공화국', common: '모리타니' },
      nld: {
        official: 'Islamitische Republiek Mauritanië',
        common: 'Mauritanië'
      },
      per: { official: 'جمهوری اسلامی موریتانی', common: 'موریتانی' },
      pol: { official: 'Islamska Republika Mauretańska', common: 'Mauretania' },
      por: {
        official: 'República Islâmica da Mauritânia',
        common: 'Mauritânia'
      },
      rus: {
        official: 'Исламская Республика Мавритания',
        common: 'Мавритания'
      },
      slk: { official: 'Mauritánska islamská republika', common: 'Mauritánia' },
      spa: {
        official: 'República Islámica de Mauritania',
        common: 'Mauritania'
      },
      swe: {
        official: 'Islamiska republiken Mauretanien',
        common: 'Mauretanien'
      },
      tur: { official: 'Moritanya İslam Cumhuriyeti', common: 'Moritanya' },
      urd: { official: 'اسلامی جمہوریہ موریتانیہ', common: 'موریتانیہ' },
      zho: { official: '毛里塔尼亚伊斯兰共和国', common: '毛里塔尼亚' }
    },
    latlng: [20.0, -12.0],
    landlocked: false,
    borders: ['DZA', 'MLI', 'SEN', 'ESH'],
    area: 1030700.0,
    demonyms: {
      eng: { f: 'Mauritanian', m: 'Mauritanian' },
      fra: { f: 'Mauritanienne', m: 'Mauritanien' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/im2MmQ5jFjzxWBks5',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192763'
    },
    population: 4649660,
    gini: { 2014: 32.6 },
    fifa: 'MTN',
    car: { signs: ['RIM'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/mr.png',
      svg: 'https://flagcdn.com/mr.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mr.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mr.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.07, -15.97] }
  },
  {
    name: {
      common: 'Eswatini',
      official: 'Kingdom of Eswatini',
      nativeName: {
        eng: { official: 'Kingdom of Eswatini', common: 'Eswatini' },
        ssw: { official: 'Umbuso weSwatini', common: 'eSwatini' }
      }
    },
    tld: ['.sz'],
    cca2: 'SZ',
    ccn3: '748',
    cca3: 'SWZ',
    cioc: 'SWZ',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      SZL: { name: 'Swazi lilangeni', symbol: 'L' },
      ZAR: { name: 'South African rand', symbol: 'R' }
    },
    idd: { root: '+2', suffixes: ['68'] },
    capital: ['Mbabane'],
    altSpellings: [
      'SZ',
      'Swaziland',
      'weSwatini',
      'Swatini',
      'Ngwane',
      'Kingdom of Eswatini',
      'Umbuso weSwatini'
    ],
    region: 'Africa',
    subregion: 'Southern Africa',
    languages: { eng: 'English', ssw: 'Swazi' },
    translations: {
      ara: { official: 'مملكة إسواتيني', common: 'إسواتيني' },
      bre: { official: 'Rouantelezh Eswatini', common: 'Eswatini' },
      ces: { official: 'Svazijské království', common: 'Svazijsko' },
      cym: { official: 'Kingdom of Eswatini', common: 'Eswatini' },
      deu: { official: 'Königreich Eswatini', common: 'Swasiland' },
      est: { official: 'eSwatini Kuningriik', common: 'Svaasimaa' },
      fin: { official: 'Swazimaan kuningaskunta', common: 'Swazimaa' },
      fra: { official: 'Royaume d’Eswatini', common: 'Swaziland' },
      hrv: { official: 'Kraljevina eSwatini', common: 'Svazi' },
      hun: { official: 'Szváziföldi Királyság', common: 'Szváziföld' },
      ita: { official: 'Regno di eSwatini', common: 'Swaziland' },
      jpn: { official: 'スワジランド王国', common: 'スワジランド' },
      kor: { official: '에스와티니 왕국', common: '에스와티니' },
      nld: { official: 'Koninkrijk eSwatini', common: 'Swaziland' },
      per: { official: 'پادشاهی سوازیلند', common: 'اسواتینی' },
      pol: { official: 'Królestwo Suazi', common: 'Suazi' },
      por: { official: 'Reino de eSwatini', common: 'Suazilândia' },
      rus: { official: 'Королевство Свазиленд', common: 'Свазиленд' },
      slk: { official: 'Svazijské kráľovstvo', common: 'Svazijsko' },
      spa: { official: 'Reino de eSwatini', common: 'Suazilandia' },
      swe: { official: 'Konungariket Eswatini', common: 'Swaziland' },
      tur: { official: 'Esvatini Krallığı', common: 'Esvatini' },
      urd: { official: 'مملکتِ سوازی لینڈ', common: 'سوازی لینڈ' },
      zho: { official: '斯威士兰王国', common: '斯威士兰' }
    },
    latlng: [-26.5, 31.5],
    landlocked: true,
    borders: ['MOZ', 'ZAF'],
    area: 17364.0,
    demonyms: {
      eng: { f: 'Swazi', m: 'Swazi' },
      fra: { f: 'Swazie', m: 'Swazie' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDFF',
    maps: {
      googleMaps: 'https://goo.gl/maps/cUY79eqQihFSE8hV6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/88210'
    },
    population: 1160164,
    gini: { 2016: 54.6 },
    fifa: 'SWZ',
    car: { signs: ['SD'], side: 'left' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/sz.png',
      svg: 'https://flagcdn.com/sz.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-26.32, 31.13] },
    postalCode: { format: '@###', regex: '^([A-Z]\\d{3})$' }
  },
  {
    name: {
      common: 'Mauritius',
      official: 'Republic of Mauritius',
      nativeName: {
        eng: { official: 'Republic of Mauritius', common: 'Mauritius' },
        fra: { official: 'République de Maurice', common: 'Maurice' },
        mfe: { official: 'Republik Moris', common: 'Moris' }
      }
    },
    tld: ['.mu'],
    cca2: 'MU',
    ccn3: '480',
    cca3: 'MUS',
    cioc: 'MRI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MUR: { name: 'Mauritian rupee', symbol: '₨' } },
    idd: { root: '+2', suffixes: ['30'] },
    capital: ['Port Louis'],
    altSpellings: ['MU', 'Republic of Mauritius', 'République de Maurice'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { eng: 'English', fra: 'French', mfe: 'Mauritian Creole' },
    translations: {
      ara: { official: 'جمهورية موريشيوس', common: 'موريشيوس' },
      bre: { official: 'Republik Moris', common: 'Moris' },
      ces: { official: 'Mauricijská republika', common: 'Mauricius' },
      cym: { official: 'Republic of Mauritius', common: 'Mauritius' },
      deu: { official: 'Republik Mauritius', common: 'Mauritius' },
      est: { official: 'Mauritiuse Vabariik', common: 'Mauritius' },
      fin: { official: 'Mauritiuksen tasavalta', common: 'Mauritius' },
      fra: { official: 'République de Maurice', common: 'Île Maurice' },
      hrv: { official: 'Republika Mauricijus', common: 'Mauricijus' },
      hun: { official: 'Mauritiusi Köztársaság', common: 'Mauritius' },
      ita: { official: 'Repubblica di Mauritius', common: 'Mauritius' },
      jpn: { official: 'モーリシャス共和国', common: 'モーリシャス' },
      kor: { official: '모리셔스 공화국', common: '모리셔스' },
      nld: { official: 'Republiek Mauritius', common: 'Mauritius' },
      per: { official: 'جمهوری موریس', common: 'موریس' },
      pol: { official: 'Republika Mauritiusu', common: 'Mauritius' },
      por: { official: 'República das Maurícias', common: 'Maurício' },
      rus: { official: 'Республика Маврикий', common: 'Маврикий' },
      slk: { official: 'Maurícijská republika', common: 'Maurícius' },
      spa: { official: 'República de Mauricio', common: 'Mauricio' },
      swe: { official: 'Republiken Mauritius', common: 'Mauritius' },
      tur: { official: 'Mauritius Cumhuriyeti', common: 'Mauritius' },
      urd: { official: 'جمہوریہ موریشس', common: 'موریشس' },
      zho: { official: '毛里求斯共和国', common: '毛里求斯' }
    },
    latlng: [-20.28333333, 57.55],
    landlocked: false,
    area: 2040.0,
    demonyms: {
      eng: { f: 'Mauritian', m: 'Mauritian' },
      fra: { f: 'Mauricienne', m: 'Mauricien' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDFA',
    maps: {
      googleMaps: 'https://goo.gl/maps/PpKtZ4W3tir5iGrz7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/535828'
    },
    population: 1265740,
    gini: { 2017: 36.8 },
    fifa: 'MRI',
    car: { signs: ['MS'], side: 'left' },
    timezones: ['UTC+04:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/mu.png',
      svg: 'https://flagcdn.com/mu.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mu.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mu.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-20.15, 57.48] }
  },
  {
    name: {
      common: 'Niger',
      official: 'Republic of Niger',
      nativeName: { fra: { official: 'République du Niger', common: 'Niger' } }
    },
    tld: ['.ne'],
    cca2: 'NE',
    ccn3: '562',
    cca3: 'NER',
    cioc: 'NIG',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XOF: { name: 'West African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['27'] },
    capital: ['Niamey'],
    altSpellings: ['NE', 'Nijar'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جمهورية النيجر', common: 'النيجر' },
      bre: { official: 'Republik Niger', common: 'Niger' },
      ces: { official: 'Nigerská republika', common: 'Niger' },
      cym: { official: 'Republic of Niger', common: 'Niger' },
      deu: { official: 'Republik Niger', common: 'Niger' },
      est: { official: 'Nigeri Vabariik', common: 'Niger' },
      fin: { official: 'Nigerin tasavalta', common: 'Niger' },
      fra: { official: 'République du Niger', common: 'Niger' },
      hrv: { official: 'Republika Niger', common: 'Niger' },
      hun: { official: 'Nigeri Köztársaság', common: 'Niger' },
      ita: { official: 'Repubblica del Niger', common: 'Niger' },
      jpn: { official: 'ニジェール共和国', common: 'ニジェール' },
      kor: { official: '니제르 공화국', common: '니제르' },
      nld: { official: 'Republiek Niger', common: 'Niger' },
      per: { official: 'جمهوری نیجر', common: 'نیجر' },
      pol: { official: 'Republika Nigru', common: 'Niger' },
      por: { official: 'República do Níger', common: 'Níger' },
      rus: { official: 'Республика Нигер', common: 'Нигер' },
      slk: { official: 'Nigérská republika', common: 'Niger' },
      spa: { official: 'República de Níger', common: 'Níger' },
      swe: { official: 'Republiken Niger', common: 'Niger' },
      tur: { official: 'Nijer Cumhuriyeti', common: 'Nijer' },
      urd: { official: 'جمہوریہ نائجر', common: 'نائجر' },
      zho: { official: '尼日尔共和国', common: '尼日尔' }
    },
    latlng: [16.0, 8.0],
    landlocked: true,
    borders: ['DZA', 'BEN', 'BFA', 'TCD', 'LBY', 'MLI', 'NGA'],
    area: 1267000.0,
    demonyms: {
      eng: { f: 'Nigerien', m: 'Nigerien' },
      fra: { f: 'Nigérienne', m: 'Nigérien' }
    },
    flag: '\uD83C\uDDF3\uD83C\uDDEA',
    maps: {
      googleMaps: 'https://goo.gl/maps/VKNU2TLsZcgxM49c8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192786'
    },
    population: 24206636,
    gini: { 2014: 34.3 },
    fifa: 'NIG',
    car: { signs: ['RN'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ne.png',
      svg: 'https://flagcdn.com/ne.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ne.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ne.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [13.52, 2.12] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Comoros',
      official: 'Union of the Comoros',
      nativeName: {
        ara: { official: 'الاتحاد القمري', common: 'القمر‎' },
        fra: { official: 'Union des Comores', common: 'Comores' },
        zdj: { official: 'Udzima wa Komori', common: 'Komori' }
      }
    },
    tld: ['.km'],
    cca2: 'KM',
    ccn3: '174',
    cca3: 'COM',
    cioc: 'COM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { KMF: { name: 'Comorian franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['69'] },
    capital: ['Moroni'],
    altSpellings: [
      'KM',
      'Union of the Comoros',
      'Union des Comores',
      'Udzima wa Komori',
      'al-Ittiḥād al-Qumurī'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { ara: 'Arabic', fra: 'French', zdj: 'Comorian' },
    translations: {
      ara: { official: 'الإتحاد القمري', common: 'جزر القمر' },
      bre: { official: 'Unaniezh Komorez', common: 'Komorez' },
      ces: { official: 'Komorský svaz', common: 'Komory' },
      cym: { official: 'Undeb y Comoros', common: 'Y Comoros' },
      deu: { official: 'Union der Komoren', common: 'Komoren' },
      est: { official: 'Komoori Liit', common: 'Komoorid' },
      fin: { official: 'Komorien liitto', common: 'Komorit' },
      fra: { official: 'Union des Comores', common: 'Comores' },
      hrv: { official: 'Savez Komori', common: 'Komori' },
      hun: { official: 'Comore-szigeteki Unió', common: 'Comore-szigetek' },
      ita: { official: 'Unione delle Comore', common: 'Comore' },
      jpn: { official: 'コモロ連合', common: 'コモロ' },
      kor: { official: '코모로 연방', common: '코모로' },
      nld: { official: 'Unie van de Comoren', common: 'Comoren' },
      per: { official: 'مجمع‌الجزایر قمر', common: 'اتحاد قُمُر' },
      pol: { official: 'Związek Komorów', common: 'Komory' },
      por: { official: 'União das Comores', common: 'Comores' },
      rus: { official: 'Союз Коморских Островов', common: 'Коморы' },
      slk: { official: 'Komorská únia', common: 'Komory' },
      spa: { official: 'Unión de las Comoras', common: 'Comoras' },
      swe: { official: 'Unionen Komorerna', common: 'Komorerna' },
      tur: { official: 'Komorlar Birliği', common: 'Komorlar' },
      urd: { official: 'اتحاد القمری', common: 'القمری' },
      zho: { official: '科摩罗联盟', common: '科摩罗' }
    },
    latlng: [-12.16666666, 44.25],
    landlocked: false,
    area: 1862.0,
    demonyms: {
      eng: { f: 'Comoran', m: 'Comoran' },
      fra: { f: 'Comorienne', m: 'Comorien' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/eas4GP28C1GyStnu6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/535790'
    },
    population: 869595,
    gini: { 2014: 45.3 },
    fifa: 'COM',
    car: { signs: ['COM'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/km.png',
      svg: 'https://flagcdn.com/km.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/km.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/km.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-11.7, 43.23] }
  },
  {
    name: {
      common: 'Uganda',
      official: 'Republic of Uganda',
      nativeName: {
        eng: { official: 'Republic of Uganda', common: 'Uganda' },
        swa: { official: 'Republic of Uganda', common: 'Uganda' }
      }
    },
    tld: ['.ug'],
    cca2: 'UG',
    ccn3: '800',
    cca3: 'UGA',
    cioc: 'UGA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { UGX: { name: 'Ugandan shilling', symbol: 'Sh' } },
    idd: { root: '+2', suffixes: ['56'] },
    capital: ['Kampala'],
    altSpellings: ['UG', 'Republic of Uganda', 'Jamhuri ya Uganda'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { eng: 'English', swa: 'Swahili' },
    translations: {
      ara: { official: 'جمهورية أوغندا', common: 'أوغندا' },
      bre: { official: 'Republik Ouganda', common: 'Ouganda' },
      ces: { official: 'Ugandská republika', common: 'Uganda' },
      cym: { official: 'Republic of Uganda', common: 'Uganda' },
      deu: { official: 'Republik Uganda', common: 'Uganda' },
      est: { official: 'Uganda Vabariik', common: 'Uganda' },
      fin: { official: 'Ugandan tasavalta', common: 'Uganda' },
      fra: { official: "République de l'Ouganda", common: 'Ouganda' },
      hrv: { official: 'Republika Uganda', common: 'Uganda' },
      hun: { official: 'Ugandai Köztársaság', common: 'Uganda' },
      ita: { official: 'Repubblica di Uganda', common: 'Uganda' },
      jpn: { official: 'ウガンダ共和国', common: 'ウガンダ' },
      kor: { official: '우간다 공화국', common: '우간다' },
      nld: { official: 'Republiek Uganda', common: 'Oeganda' },
      per: { official: 'جمهوری اوگاندا', common: 'اوگاندا' },
      pol: { official: 'Republika Ugandy', common: 'Uganda' },
      por: { official: 'República do Uganda', common: 'Uganda' },
      rus: { official: 'Республика Уганда', common: 'Уганда' },
      slk: { official: 'Ugandská republika', common: 'Uganda' },
      spa: { official: 'República de Uganda', common: 'Uganda' },
      swe: { official: 'Republiken Uganda', common: 'Uganda' },
      tur: { official: 'Uganda Cumhuriyeti', common: 'Uganda' },
      urd: { official: 'جمہوریہ یوگنڈا', common: 'یوگنڈا' },
      zho: { official: '乌干达共和国', common: '乌干达' }
    },
    latlng: [1.0, 32.0],
    landlocked: true,
    borders: ['COD', 'KEN', 'RWA', 'SSD', 'TZA'],
    area: 241550.0,
    demonyms: {
      eng: { f: 'Ugandan', m: 'Ugandan' },
      fra: { f: 'Ougandaise', m: 'Ougandais' }
    },
    flag: '\uD83C\uDDFA\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/Y7812hFiGa8LD9N68',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192796'
    },
    population: 45741000,
    gini: { 2016: 42.8 },
    fifa: 'UGA',
    car: { signs: ['EAU'], side: 'left' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ug.png',
      svg: 'https://flagcdn.com/ug.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ug.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ug.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [0.32, 32.55] }
  },
  {
    name: {
      common: 'South Sudan',
      official: 'Republic of South Sudan',
      nativeName: {
        eng: { official: 'Republic of South Sudan', common: 'South Sudan' }
      }
    },
    tld: ['.ss'],
    cca2: 'SS',
    ccn3: '728',
    cca3: 'SSD',
    cioc: 'SSD',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SSP: { name: 'South Sudanese pound', symbol: '£' } },
    idd: { root: '+2', suffixes: ['11'] },
    capital: ['Juba'],
    altSpellings: ['SS'],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية جنوب السودان', common: 'جنوب السودان' },
      bre: { official: 'Republik Soudan ar Su', common: 'Soudan ar Su' },
      ces: { official: 'Jihosúdánská republika', common: 'Jižní Súdán' },
      cym: { official: 'Republic of South Sudan', common: 'South Sudan' },
      deu: { official: 'Republik Südsudan', common: 'Südsudan' },
      est: { official: 'Lõuna-Sudaani Vabariik', common: 'Lõuna-Sudaan' },
      fin: { official: 'Etelä-Sudanin tasavalta', common: 'Etelä-Sudan' },
      fra: { official: 'République du Soudan du Sud', common: 'Soudan du Sud' },
      hrv: { official: 'Republika Južni Sudan', common: 'Južni Sudan' },
      hun: { official: 'Dél-szudáni Köztársaság', common: 'Dél-Szudán' },
      ita: {
        official: 'Repubblica del Sudan del Sud',
        common: 'Sudan del sud'
      },
      jpn: { official: '南スーダン共和国', common: '南スーダン' },
      kor: { official: '남수단 공화국', common: '남수단' },
      nld: { official: 'Republiek Zuid-Soedan', common: 'Zuid-Soedan' },
      per: { official: 'جمهوری سودان جنوبی', common: 'سودان جنوبی' },
      pol: { official: 'Republika Sudanu', common: 'Sudan' },
      por: { official: 'República do Sudão do Sul', common: 'Sudão do Sul' },
      rus: { official: 'Республика Южный Судан', common: 'Южный Судан' },
      slk: { official: 'Juhosudánska republika', common: 'Južný Sudán' },
      spa: { official: 'República de Sudán del Sur', common: 'Sudán del Sur' },
      swe: { official: 'Republiken Sydsudan', common: 'Sydsudan' },
      tur: { official: 'Güney Sudan Cumhuriyeti', common: 'Güney Sudan' },
      urd: { official: 'جمہوریہ جنوبی سوڈان', common: 'جنوبی سوڈان' },
      zho: { official: '南苏丹共和国', common: '南苏丹' }
    },
    latlng: [7.0, 30.0],
    landlocked: true,
    borders: ['CAF', 'COD', 'ETH', 'KEN', 'SDN', 'UGA'],
    area: 619745.0,
    demonyms: {
      eng: { f: 'South Sudanese', m: 'South Sudanese' },
      fra: { f: 'Sud-Soudanaise', m: 'Sud-Soudanais' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDF8',
    maps: {
      googleMaps: 'https://goo.gl/maps/Zm1AYCXb9HSNF1P27',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1656678'
    },
    population: 11193729,
    gini: { 2016: 44.1 },
    fifa: 'SSD',
    car: { signs: [''], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ss.png',
      svg: 'https://flagcdn.com/ss.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ss.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ss.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [4.85, 31.62] }
  },
  {
    name: {
      common: 'Benin',
      official: 'Republic of Benin',
      nativeName: { fra: { official: 'République du Bénin', common: 'Bénin' } }
    },
    tld: ['.bj'],
    cca2: 'BJ',
    ccn3: '204',
    cca3: 'BEN',
    cioc: 'BEN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XOF: { name: 'West African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['29'] },
    capital: ['Porto-Novo'],
    altSpellings: ['BJ', 'Republic of Benin', 'République du Bénin'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جمهورية بنين', common: 'بنين' },
      bre: { official: 'Republik Benin', common: 'Benin' },
      ces: { official: 'Beninská republika', common: 'Benin' },
      cym: { official: 'Gweriniaeth Benin', common: 'Benin' },
      deu: { official: 'Republik Benin', common: 'Benin' },
      est: { official: 'Benini Vabariik', common: 'Benin' },
      fin: { official: 'Beninin tasavalta', common: 'Benin' },
      fra: { official: 'République du Bénin', common: 'Bénin' },
      hrv: { official: 'Republika Benin', common: 'Benin' },
      hun: { official: 'Benini Köztársaság', common: 'Benin' },
      ita: { official: 'Repubblica del Benin', common: 'Benin' },
      jpn: { official: 'ベナン共和国', common: 'ベナン' },
      kor: { official: '베냉 공화국', common: '베냉' },
      nld: { official: 'Republiek Benin', common: 'Benin' },
      per: { official: 'جمهوری بنین', common: 'بنین' },
      pol: { official: 'Benin', common: 'Benin' },
      por: { official: 'República do Benin', common: 'Benin' },
      rus: { official: 'Республика Бенин', common: 'Бенин' },
      slk: { official: 'Beninská republika', common: 'Benin' },
      spa: { official: 'República de Benin', common: 'Benín' },
      swe: { official: 'Republiken Benin', common: 'Benin' },
      tur: { official: 'Benin Cumhuriyeti', common: 'Benin' },
      urd: { official: 'جمہوریہ بینن', common: 'بینن' },
      zho: { official: '贝宁共和国', common: '贝宁' }
    },
    latlng: [9.5, 2.25],
    landlocked: false,
    borders: ['BFA', 'NER', 'NGA', 'TGO'],
    area: 112622.0,
    demonyms: {
      eng: { f: 'Beninese', m: 'Beninese' },
      fra: { f: 'Béninoise', m: 'Béninois' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDEF',
    maps: {
      googleMaps: 'https://goo.gl/maps/uMw1BsHEXQYgVFFu6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192784'
    },
    population: 12123198,
    gini: { 2015: 47.8 },
    fifa: 'BEN',
    car: { signs: ['DY'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/bj.png',
      svg: 'https://flagcdn.com/bj.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bj.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bj.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [6.48, 2.62] }
  },
  {
    name: {
      common: 'Guinea-Bissau',
      official: 'Republic of Guinea-Bissau',
      nativeName: {
        por: { official: 'República da Guiné-Bissau', common: 'Guiné-Bissau' },
        pov: { official: 'República da Guiné-Bissau', common: 'Guiné-Bissau' }
      }
    },
    tld: ['.gw'],
    cca2: 'GW',
    ccn3: '624',
    cca3: 'GNB',
    cioc: 'GBS',
    independent: true,
    status: 'officially-assigned',
    unMember: false,
    currencies: { XOF: { name: 'West African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['45'] },
    capital: ['Bissau'],
    altSpellings: [
      'GW',
      'Republic of Guinea-Bissau',
      'República da Guiné-Bissau'
    ],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { por: 'Portuguese', pov: 'Upper Guinea Creole' },
    translations: {
      ara: { official: 'جمهورية غينيا بيساو', common: 'غينيا بيساو' },
      bre: { official: 'Republik Ginea-Bissau', common: 'Ginea-Bissau' },
      ces: { official: 'Republika Guinea-Bissau', common: 'Guinea-Bissau' },
      cym: { official: 'Republic of Guinea-Bissau', common: 'Guinea-Bissau' },
      deu: { official: 'Republik Guinea-Bissau', common: 'Guinea-Bissau' },
      est: { official: 'Guinea-Bissau Vabariik', common: 'Guinea-Bissau' },
      fin: { official: 'Guinea-Bissaun tasavalta', common: 'Guinea-Bissau' },
      fra: { official: 'République de Guinée-Bissau', common: 'Guinée-Bissau' },
      hrv: { official: 'Republika Gvineja Bisau', common: 'Gvineja Bisau' },
      hun: { official: 'Bissau-Guineai Köztársaság', common: 'Bissau-Guinea' },
      ita: { official: 'Repubblica di Guinea-Bissau', common: 'Guinea-Bissau' },
      jpn: { official: 'ギニアビサウ共和国', common: 'ギニアビサウ' },
      kor: { official: '기니비사우 공화국', common: '기니비사우' },
      nld: { official: 'Republiek Guinee-Bissau', common: 'Guinee-Bissau' },
      per: { official: 'جمهوری گینه بیسائو', common: 'گینه بیسائو' },
      pol: { official: 'Republika Gwinei Bissau', common: 'Gwinea Bissau' },
      por: { official: 'República da Guiné-Bissau', common: 'Guiné-Bissau' },
      rus: { official: 'Республика Гвинея -Бисау', common: 'Гвинея-Бисау' },
      slk: {
        official: 'Guinejsko-bissauská republika',
        common: 'Guinea-Bissau'
      },
      spa: { official: 'República de Guinea-Bissau', common: 'Guinea-Bisáu' },
      swe: { official: 'Republiken Guinea-Bissau', common: 'Guinea-Bissau' },
      tur: { official: 'Gine-Bissau Cumhuriyeti', common: 'Gine-Bissau' },
      urd: { official: 'جمہوریہ گنی بساؤ', common: 'گنی بساؤ' },
      zho: { official: '几内亚比绍共和国', common: '几内亚比绍' }
    },
    latlng: [12.0, -15.0],
    landlocked: false,
    borders: ['GIN', 'SEN'],
    area: 36125.0,
    demonyms: {
      eng: { f: 'Guinea-Bissauan', m: 'Guinea-Bissauan' },
      fra: { f: 'Bissau-Guinéenne', m: 'Bissau-Guinéen' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/5Wyaz17miUc1zLc67',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192776'
    },
    population: 1967998,
    gini: { 2010: 50.7 },
    fifa: 'GNB',
    car: { signs: ['RGB'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/gw.png',
      svg: 'https://flagcdn.com/gw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gw.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [11.85, -15.58] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Rwanda',
      official: 'Republic of Rwanda',
      nativeName: {
        eng: { official: 'Republic of Rwanda', common: 'Rwanda' },
        fra: { official: 'République rwandaise', common: 'Rwanda' },
        kin: { official: "Repubulika y'u Rwanda", common: 'Rwanda' }
      }
    },
    tld: ['.rw'],
    cca2: 'RW',
    ccn3: '646',
    cca3: 'RWA',
    cioc: 'RWA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { RWF: { name: 'Rwandan franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['50'] },
    capital: ['Kigali'],
    altSpellings: [
      'RW',
      'Republic of Rwanda',
      "Repubulika y'u Rwanda",
      'République du Rwanda'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { eng: 'English', fra: 'French', kin: 'Kinyarwanda' },
    translations: {
      ara: { official: 'جمهورية رواندا', common: 'رواندا' },
      bre: { official: 'Republik Rwanda', common: 'Rwanda' },
      ces: { official: 'Rwandská republika', common: 'Rwanda' },
      cym: { official: 'Republic of Rwanda', common: 'Rwanda' },
      deu: { official: 'Republik Ruanda', common: 'Ruanda' },
      est: { official: 'Rwanda Vabariik', common: 'Rwanda' },
      fin: { official: 'Ruandan tasavalta', common: 'Ruanda' },
      fra: { official: 'République rwandaise', common: 'Rwanda' },
      hrv: { official: 'Republika Ruandi', common: 'Ruanda' },
      hun: { official: 'Ruandai Köztársaság', common: 'Ruanda' },
      ita: { official: 'Repubblica del Ruanda', common: 'Ruanda' },
      jpn: { official: 'ルワンダ共和国', common: 'ルワンダ' },
      kor: { official: '르완다 공화국', common: '르완다' },
      nld: { official: 'Republiek Rwanda', common: 'Rwanda' },
      per: { official: 'جمهوری رواندا', common: 'رواندا' },
      pol: { official: 'Republika Rwandy', common: 'Rwanda' },
      por: { official: 'República do Ruanda', common: 'Ruanda' },
      rus: { official: 'Республика Руанда', common: 'Руанда' },
      slk: { official: 'Rwandská republika', common: 'Rwanda' },
      spa: { official: 'República de Rwanda', common: 'Ruanda' },
      swe: { official: 'Republiken Rwanda', common: 'Rwanda' },
      tur: { official: 'Ruanda Cumhuriyeti', common: 'Ruanda' },
      urd: { official: 'جمہوریہ روانڈا', common: 'روانڈا' },
      zho: { official: '卢旺达共和国', common: '卢旺达' }
    },
    latlng: [-2.0, 30.0],
    landlocked: true,
    borders: ['BDI', 'COD', 'TZA', 'UGA'],
    area: 26338.0,
    demonyms: {
      eng: { f: 'Rwandan', m: 'Rwandan' },
      fra: { f: 'Rwandaise', m: 'Rwandais' }
    },
    flag: '\uD83C\uDDF7\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/j5xb5r7CLqjYbyP86',
      openStreetMaps: 'https://www.openstreetmap.org/relation/171496'
    },
    population: 12952209,
    gini: { 2016: 43.7 },
    fifa: 'RWA',
    car: { signs: ['RWA'], side: 'right' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/rw.png',
      svg: 'https://flagcdn.com/rw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/rw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/rw.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-1.95, 30.05] }
  },
  {
    name: {
      common: 'Ghana',
      official: 'Republic of Ghana',
      nativeName: { eng: { official: 'Republic of Ghana', common: 'Ghana' } }
    },
    tld: ['.gh'],
    cca2: 'GH',
    ccn3: '288',
    cca3: 'GHA',
    cioc: 'GHA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { GHS: { name: 'Ghanaian cedi', symbol: '₵' } },
    idd: { root: '+2', suffixes: ['33'] },
    capital: ['Accra'],
    altSpellings: ['GH'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية غانا', common: 'غانا' },
      bre: { official: 'Republik Ghana', common: 'Ghana' },
      ces: { official: 'Ghanská republika', common: 'Ghana' },
      cym: { official: 'Republic of Ghana', common: 'Ghana' },
      deu: { official: 'Republik Ghana', common: 'Ghana' },
      est: { official: 'Ghana Vabariik', common: 'Ghana' },
      fin: { official: 'Ghanan tasavalta', common: 'Ghana' },
      fra: { official: 'République du Ghana', common: 'Ghana' },
      hrv: { official: 'Republika Gana', common: 'Gana' },
      hun: { official: 'Ghánai Köztársaság', common: 'Ghána' },
      ita: { official: 'Repubblica del Ghana', common: 'Ghana' },
      jpn: { official: 'ガーナ共和国', common: 'ガーナ' },
      kor: { official: '가나 공화국', common: '가나' },
      nld: { official: 'Republiek Ghana', common: 'Ghana' },
      per: { official: 'جمهوری غنا', common: 'غنا' },
      pol: { official: 'Republika Ghany', common: 'Ghana' },
      por: { official: 'República do Gana', common: 'Gana' },
      rus: { official: 'Республика Гана', common: 'Гана' },
      slk: { official: 'Ghanská republika', common: 'Ghana' },
      spa: { official: 'República de Ghana', common: 'Ghana' },
      swe: { official: 'Republiken Ghana', common: 'Ghana' },
      tur: { official: 'Gana Cumhuriyeti', common: 'Gana' },
      urd: { official: 'جمہوریہ گھانا', common: 'گھانا' },
      zho: { official: '加纳共和国', common: '加纳' }
    },
    latlng: [8.0, -2.0],
    landlocked: false,
    borders: ['BFA', 'CIV', 'TGO'],
    area: 238533.0,
    demonyms: {
      eng: { f: 'Ghanaian', m: 'Ghanaian' },
      fra: { f: 'Ghanéenne', m: 'Ghanéen' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDED',
    maps: {
      googleMaps: 'https://goo.gl/maps/Avy5RSmdsXFBaiXq8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192781'
    },
    population: 31072945,
    gini: { 2016: 43.5 },
    fifa: 'GHA',
    car: { signs: ['GH'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/gh.png',
      svg: 'https://flagcdn.com/gh.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gh.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gh.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [5.55, -0.22] }
  },
  {
    name: {
      common: 'Djibouti',
      official: 'Republic of Djibouti',
      nativeName: {
        ara: { official: 'جمهورية جيبوتي', common: 'جيبوتي‎' },
        fra: { official: 'République de Djibouti', common: 'Djibouti' }
      }
    },
    tld: ['.dj'],
    cca2: 'DJ',
    ccn3: '262',
    cca3: 'DJI',
    cioc: 'DJI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { DJF: { name: 'Djiboutian franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['53'] },
    capital: ['Djibouti'],
    altSpellings: [
      'DJ',
      'Jabuuti',
      'Gabuuti',
      'Republic of Djibouti',
      'République de Djibouti',
      'Gabuutih Ummuuno',
      'Jamhuuriyadda Jabuuti'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { ara: 'Arabic', fra: 'French' },
    translations: {
      ara: { official: 'جمهورية جيبوتي', common: 'جيبوتي' },
      bre: { official: 'Republik Djibouti', common: 'Djibouti' },
      ces: { official: 'Džibutská republika', common: 'Džibutsko' },
      cym: { official: 'Gweriniaeth Jibwti', common: 'Jibwti' },
      deu: { official: 'Republik Dschibuti', common: 'Dschibuti' },
      est: { official: 'Djibouti Vabariik', common: 'Djibouti' },
      fin: { official: 'Dijiboutin tasavalta', common: 'Dijibouti' },
      fra: { official: 'République de Djibouti', common: 'Djibouti' },
      hrv: { official: 'Republika Džibuti', common: 'Džibuti' },
      hun: { official: 'Dzsibuti Köztársaság', common: 'Dzsibuti' },
      ita: { official: 'Repubblica di Gibuti', common: 'Gibuti' },
      jpn: { official: 'ジブチ共和国', common: 'ジブチ' },
      kor: { official: '지부티 공화국', common: '지부티' },
      nld: { official: 'Republiek Djibouti', common: 'Djibouti' },
      per: { official: 'جمهوری جیبوتی', common: 'جیبوتی' },
      pol: { official: 'Republika Dżibuti', common: 'Dżibuti' },
      por: { official: 'República do Djibouti', common: 'Djibouti' },
      rus: { official: 'Республика Джибути', common: 'Джибути' },
      slk: { official: 'ǅibutská republika', common: 'ǅibutsko' },
      spa: { official: 'República de Djibouti', common: 'Djibouti' },
      swe: { official: 'Republiken Djibouti', common: 'Djibouti' },
      tur: { official: 'Cibuti Cumhuriyeti', common: 'Cibuti' },
      urd: { official: 'جمہوریہ جبوتی', common: 'جبوتی' },
      zho: { official: '吉布提共和国', common: '吉布提' }
    },
    latlng: [11.5, 43.0],
    landlocked: false,
    borders: ['ERI', 'ETH', 'SOM'],
    area: 23200.0,
    demonyms: {
      eng: { f: 'Djibouti', m: 'Djibouti' },
      fra: { f: 'Djiboutienne', m: 'Djiboutien' }
    },
    flag: '\uD83C\uDDE9\uD83C\uDDEF',
    maps: {
      googleMaps: 'https://goo.gl/maps/V1HWfzN3bS1kwf4C6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192801'
    },
    population: 988002,
    gini: { 2017: 41.6 },
    fifa: 'DJI',
    car: { signs: ['DJI'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/dj.png',
      svg: 'https://flagcdn.com/dj.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/dj.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/dj.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [11.58, 43.15] }
  },
  {
    name: {
      common: 'Cameroon',
      official: 'Republic of Cameroon',
      nativeName: {
        eng: { official: 'Republic of Cameroon', common: 'Cameroon' },
        fra: { official: 'République du Cameroun', common: 'Cameroun' }
      }
    },
    tld: ['.cm'],
    cca2: 'CM',
    ccn3: '120',
    cca3: 'CMR',
    cioc: 'CMR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XAF: { name: 'Central African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['37'] },
    capital: ['Yaoundé'],
    altSpellings: ['CM', 'Republic of Cameroon', 'République du Cameroun'],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { eng: 'English', fra: 'French' },
    translations: {
      ara: { official: 'جمهورية الكاميرون', common: 'الكاميرون' },
      bre: { official: 'Republik Kameroun', common: 'Kameroun' },
      ces: { official: 'Kamerunská republika', common: 'Kamerun' },
      cym: { official: 'Gweriniaeth Camerŵn', common: 'Camerŵn' },
      deu: { official: 'Republik Kamerun', common: 'Kamerun' },
      est: { official: 'Kameruni Vabariik', common: 'Kamerun' },
      fin: { official: 'Kamerunin tasavalta', common: 'Kamerun' },
      fra: { official: 'République du Cameroun', common: 'Cameroun' },
      hrv: { official: 'Republika Kamerun', common: 'Kamerun' },
      hun: { official: 'Kameruni Köztársaság', common: 'Kamerun' },
      ita: { official: 'Repubblica del Camerun', common: 'Camerun' },
      jpn: { official: 'カメルーン共和国', common: 'カメルーン' },
      kor: { official: '카메룬 공화국', common: '카메룬' },
      nld: { official: 'Republiek Kameroen', common: 'Kameroen' },
      per: { official: 'جمهوری کامِرون', common: 'کامِرون' },
      pol: { official: 'Republika Kamerunu', common: 'Kamerun' },
      por: { official: 'República dos Camarões', common: 'Camarões' },
      rus: { official: 'Республика Камерун', common: 'Камерун' },
      slk: { official: 'Kamerunská republika', common: 'Kamerun' },
      spa: { official: 'República de Camerún', common: 'Camerún' },
      swe: { official: 'Republiken Kamerun', common: 'Kamerun' },
      tur: { official: 'Kamerun Cumhuriyeti', common: 'Kamerun' },
      urd: { official: 'جمہوریہ کیمرون', common: 'کیمرون' },
      zho: { official: '喀麦隆共和国', common: '喀麦隆' }
    },
    latlng: [6.0, 12.0],
    landlocked: false,
    borders: ['CAF', 'TCD', 'COG', 'GNQ', 'GAB', 'NGA'],
    area: 475442.0,
    demonyms: {
      eng: { f: 'Cameroonian', m: 'Cameroonian' },
      fra: { f: 'Camerounaise', m: 'Camerounais' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/JqiipHgFboG3rBJh9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192830'
    },
    population: 26545864,
    gini: { 2014: 46.6 },
    fifa: 'CMR',
    car: { signs: ['CAM'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/cm.png',
      svg: 'https://flagcdn.com/cm.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cm.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cm.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [3.85, 11.5] }
  },
  {
    name: {
      common: 'Zambia',
      official: 'Republic of Zambia',
      nativeName: { eng: { official: 'Republic of Zambia', common: 'Zambia' } }
    },
    tld: ['.zm'],
    cca2: 'ZM',
    ccn3: '894',
    cca3: 'ZMB',
    cioc: 'ZAM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { ZMW: { name: 'Zambian kwacha', symbol: 'ZK' } },
    idd: { root: '+2', suffixes: ['60'] },
    capital: ['Lusaka'],
    altSpellings: ['ZM', 'Republic of Zambia'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية زامبيا', common: 'زامبيا' },
      bre: { official: 'Republik Zambia', common: 'Zambia' },
      ces: { official: 'Zambijská republika', common: 'Zambie' },
      cym: { official: 'Republic of Zambia', common: 'Zambia' },
      deu: { official: 'Republik Sambia', common: 'Sambia' },
      est: { official: 'Sambia Vabariik', common: 'Sambia' },
      fin: { official: 'Sambian tasavalta', common: 'Sambia' },
      fra: { official: 'République de Zambie', common: 'Zambie' },
      hrv: { official: 'Republika Zambija', common: 'Zambija' },
      hun: { official: 'Zambiai Köztársaság', common: 'Zambia' },
      ita: { official: 'Repubblica di Zambia', common: 'Zambia' },
      jpn: { official: 'ザンビア共和国', common: 'ザンビア' },
      kor: { official: '잠비아 공화국', common: '잠비아' },
      nld: { official: 'Republiek Zambia', common: 'Zambia' },
      per: { official: 'جمهوری زامبیا', common: 'زامبیا' },
      pol: { official: 'Republika Zambii', common: 'Zambia' },
      por: { official: 'República da Zâmbia', common: 'Zâmbia' },
      rus: { official: 'Республика Замбия', common: 'Замбия' },
      slk: { official: 'Zambijská republika', common: 'Zambia' },
      spa: { official: 'República de Zambia', common: 'Zambia' },
      swe: { official: 'Republiken Zambia', common: 'Zambia' },
      tur: { official: 'Zambiya Cumhuriyeti', common: 'Zambiya' },
      urd: { official: 'جمہوریہ زیمبیا', common: 'زیمبیا' },
      zho: { official: '赞比亚共和国', common: '赞比亚' }
    },
    latlng: [-15.0, 30.0],
    landlocked: true,
    borders: ['AGO', 'BWA', 'COD', 'MWI', 'MOZ', 'NAM', 'TZA', 'ZWE'],
    area: 752612.0,
    demonyms: {
      eng: { f: 'Zambian', m: 'Zambian' },
      fra: { f: 'Zambienne', m: 'Zambien' }
    },
    flag: '\uD83C\uDDFF\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/mweBcqvW8TppZW6q9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/195271'
    },
    population: 18383956,
    gini: { 2015: 57.1 },
    fifa: 'ZAM',
    car: { signs: ['RNR'], side: 'left' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/zm.png',
      svg: 'https://flagcdn.com/zm.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/zm.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/zm.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-15.42, 28.28] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'British Indian Ocean Territory',
      official: 'British Indian Ocean Territory',
      nativeName: {
        eng: {
          official: 'British Indian Ocean Territory',
          common: 'British Indian Ocean Territory'
        }
      }
    },
    tld: ['.io'],
    cca2: 'IO',
    ccn3: '086',
    cca3: 'IOT',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+2', suffixes: ['46'] },
    capital: ['Diego Garcia'],
    altSpellings: ['IO'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'إقليم المحيط الهندي البريطاني',
        common: 'إقليم المحيط الهندي البريطاني'
      },
      bre: {
        official: 'Tiriad breizhveurat Meurvor Indez',
        common: 'Tiriad breizhveurat Meurvor Indez'
      },
      ces: {
        official: 'Britské indickooceánské území',
        common: 'Britské indickooceánské území'
      },
      cym: {
        official: 'Tiriogaeth Brydeinig Cefnfor India',
        common: 'Tiriogaeth Brydeinig Cefnfor India'
      },
      deu: {
        official: 'Britisches Territorium im Indischen Ozean',
        common: 'Britisches Territorium im Indischen Ozean'
      },
      est: {
        official: 'Briti India ookeani ala',
        common: 'Briti India ookeani ala'
      },
      fin: {
        official: 'Brittiläinen Intian valtameren alue',
        common: 'Brittiläinen Intian valtameren alue'
      },
      fra: {
        official: "Territoire britannique de l' océan Indien",
        common: "Territoire britannique de l'océan Indien"
      },
      hrv: {
        official: 'British Indian Ocean Territory',
        common: 'Britanski Indijskooceanski teritorij'
      },
      hun: {
        official: 'Brit Indiai-óceáni Terület',
        common: 'Brit Indiai-óceáni Terület'
      },
      ita: {
        official: "Territorio britannico dell'Oceano Indiano",
        common: "Territorio britannico dell'oceano indiano"
      },
      jpn: {
        official: 'イギリス領インド洋地域',
        common: 'イギリス領インド洋地域'
      },
      kor: { official: '인도 공화국', common: '인도' },
      nld: {
        official: 'Brits Indische Oceaan Territorium',
        common: 'Britse Gebieden in de Indische Oceaan'
      },
      per: {
        official: 'قلمرو بریتانیا در اقیانوس هند',
        common: 'قلمرو بریتانیا در اقیانوس هند'
      },
      pol: {
        official: 'Brytyjskie Terytorium Oceanu Indyjskiego',
        common: 'Brytyjskie Terytorium Oceanu Indyjskiego'
      },
      por: {
        official: 'British Indian Ocean Territory',
        common: 'Território Britânico do Oceano Índico'
      },
      rus: {
        official: 'Британская территория Индийского океана',
        common: 'Британская территория в Индийском океане'
      },
      slk: {
        official: 'Britské indickooceánske územie',
        common: 'Britské indickooceánske územie'
      },
      spa: {
        official: 'Territorio Británico del Océano Índico',
        common: 'Territorio Británico del Océano Índico'
      },
      swe: {
        official: 'Brittiska territoriet i Indiska Oceanen',
        common: 'Brittiska territoriet i Indiska Oceanen'
      },
      tur: {
        official: 'Britanya Hint Okyanusu Toprakları',
        common: 'Britanya Hint Okyanusu Toprakları'
      },
      urd: { official: 'برطانوی بحرہند خطہ', common: 'برطانوی بحرہند خطہ' },
      zho: { official: '英属印度洋领地', common: '英属印度洋领地' }
    },
    latlng: [-6.0, 71.5],
    landlocked: false,
    area: 60.0,
    demonyms: { eng: { f: 'Indian', m: 'Indian' } },
    flag: '\uD83C\uDDEE\uD83C\uDDF4',
    maps: {
      googleMaps: 'https://goo.gl/maps/bheNucgekVEYozoi6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1993867'
    },
    population: 3000,
    car: { signs: ['GB'], side: 'right' },
    timezones: ['UTC+06:00'],
    continents: ['Asia'],
    flags: {
      png: 'https://flagcdn.com/w320/io.png',
      svg: 'https://flagcdn.com/io.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-7.3, 72.4] }
  },
  {
    name: {
      common: 'Liberia',
      official: 'Republic of Liberia',
      nativeName: {
        eng: { official: 'Republic of Liberia', common: 'Liberia' }
      }
    },
    tld: ['.lr'],
    cca2: 'LR',
    ccn3: '430',
    cca3: 'LBR',
    cioc: 'LBR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { LRD: { name: 'Liberian dollar', symbol: '$' } },
    idd: { root: '+2', suffixes: ['31'] },
    capital: ['Monrovia'],
    altSpellings: ['LR', 'Republic of Liberia'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية ليبيريا', common: 'ليبيريا' },
      bre: { official: 'Republik Liberia', common: 'Liberia' },
      ces: { official: 'Liberijská republika', common: 'Libérie' },
      cym: { official: 'Republic of Liberia', common: 'Liberia' },
      deu: { official: 'Republik Liberia', common: 'Liberia' },
      est: { official: 'Libeeria Vabariik', common: 'Libeeria' },
      fin: { official: 'Liberian tasavalta', common: 'Liberia' },
      fra: { official: 'République du Libéria', common: 'Liberia' },
      hrv: { official: 'Republika Liberija', common: 'Liberija' },
      hun: { official: 'Libériai Köztársaság', common: 'Libéria' },
      ita: { official: 'Repubblica di Liberia', common: 'Liberia' },
      jpn: { official: 'リベリア共和国', common: 'リベリア' },
      kor: { official: '라이베리아 공화국', common: '라이베리아' },
      nld: { official: 'Republiek Liberia', common: 'Liberia' },
      per: { official: 'جمهوری لیبریا', common: 'لیبـِریا' },
      pol: { official: 'Republika Liberii', common: 'Liberia' },
      por: { official: 'República da Libéria', common: 'Libéria' },
      rus: { official: 'Республика Либерия', common: 'Либерия' },
      slk: { official: 'Libérijská republika', common: 'Libéria' },
      spa: { official: 'República de Liberia', common: 'Liberia' },
      swe: { official: 'Republiken Liberia', common: 'Liberia' },
      tur: { official: 'Liberya Cumhuriyeti', common: 'Liberya' },
      urd: { official: 'جمہوریہ لائبیریا', common: 'لائبیریا' },
      zho: { official: '利比里亚共和国', common: '利比里亚' }
    },
    latlng: [6.5, -9.5],
    landlocked: false,
    borders: ['GIN', 'CIV', 'SLE'],
    area: 111369.0,
    demonyms: {
      eng: { f: 'Liberian', m: 'Liberian' },
      fra: { f: 'Libérienne', m: 'Libérien' }
    },
    flag: '\uD83C\uDDF1\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/4VsHsc2oeGeRL3wg6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192780'
    },
    population: 5057677,
    gini: { 2016: 35.3 },
    fifa: 'LBR',
    car: { signs: ['LB'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/lr.png',
      svg: 'https://flagcdn.com/lr.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/lr.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/lr.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [6.3, -10.8] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Burundi',
      official: 'Republic of Burundi',
      nativeName: {
        fra: { official: 'République du Burundi', common: 'Burundi' },
        run: { official: "Republika y'Uburundi ", common: 'Uburundi' }
      }
    },
    tld: ['.bi'],
    cca2: 'BI',
    ccn3: '108',
    cca3: 'BDI',
    cioc: 'BDI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { BIF: { name: 'Burundian franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['57'] },
    capital: ['Gitega'],
    altSpellings: [
      'BI',
      'Republic of Burundi',
      "Republika y'Uburundi",
      'République du Burundi'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { fra: 'French', run: 'Kirundi' },
    translations: {
      ara: { official: 'جمهورية بوروندي', common: 'بوروندي' },
      bre: { official: 'Republik Burundi', common: 'Burundi' },
      ces: { official: 'Burundská republika', common: 'Burundi' },
      cym: { official: 'Gweriniaeth Bwrwndi', common: 'Bwrwndi' },
      deu: { official: 'Republik Burundi', common: 'Burundi' },
      est: { official: 'Burundi Vabariik', common: 'Burundi' },
      fin: { official: 'Burundin tasavalta', common: 'Burundi' },
      fra: { official: 'République du Burundi', common: 'Burundi' },
      hrv: { official: 'Burundi', common: 'Burundi' },
      hun: { official: 'Burundi', common: 'Burundi' },
      ita: { official: 'Repubblica del Burundi', common: 'Burundi' },
      jpn: { official: 'ブルンジ共和国', common: 'ブルンジ' },
      kor: { official: '부룬디', common: '부룬디' },
      nld: { official: 'Republiek Burundi', common: 'Burundi' },
      per: { official: 'جمهوری بوروندی', common: 'بوروندی' },
      pol: { official: 'Republika Burundi', common: 'Burundi' },
      por: { official: 'República do Burundi', common: 'Burundi' },
      rus: { official: 'Республика Бурунди', common: 'Бурунди' },
      slk: { official: 'Burundská republika', common: 'Burundi' },
      spa: { official: 'República de Burundi', common: 'Burundi' },
      swe: { official: 'Republiken Burundi', common: 'Burundi' },
      tur: { official: 'Burundi Cumhuriyeti', common: 'Burundi' },
      urd: { official: 'جمہوریہ برونڈی', common: 'برونڈی' },
      zho: { official: '布隆迪共和国', common: '布隆迪' }
    },
    latlng: [-3.5, 30.0],
    landlocked: true,
    borders: ['COD', 'RWA', 'TZA'],
    area: 27834.0,
    demonyms: {
      eng: { f: 'Burundian', m: 'Burundian' },
      fra: { f: 'Burundaise', m: 'Burundais' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDEE',
    maps: {
      googleMaps: 'https://goo.gl/maps/RXPWoRrB9tfrJpUG7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/195269'
    },
    population: 11890781,
    gini: { 2013: 38.6 },
    fifa: 'BDI',
    car: { signs: ['RU'], side: 'right' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/bi.png',
      svg: 'https://flagcdn.com/bi.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bi.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bi.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-3.43, 29.93] }
  },
  {
    name: {
      common: 'Somalia',
      official: 'Federal Republic of Somalia',
      nativeName: {
        ara: { official: 'جمهورية الصومال‎‎', common: 'الصومال‎‎' },
        som: {
          official: 'Jamhuuriyadda Federaalka Soomaaliya',
          common: 'Soomaaliya'
        }
      }
    },
    tld: ['.so'],
    cca2: 'SO',
    ccn3: '706',
    cca3: 'SOM',
    cioc: 'SOM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SOS: { name: 'Somali shilling', symbol: 'Sh' } },
    idd: { root: '+2', suffixes: ['52'] },
    capital: ['Mogadishu'],
    altSpellings: [
      'SO',
      'aṣ-Ṣūmāl',
      'Federal Republic of Somalia',
      'Jamhuuriyadda Federaalka Soomaaliya',
      'Jumhūriyyat aṣ-Ṣūmāl al-Fiderāliyya'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { ara: 'Arabic', som: 'Somali' },
    translations: {
      ara: { official: 'جمهورية الصومال الفيدرالية', common: 'الصومال' },
      bre: { official: 'Republik Kevreadel Somalia', common: 'Somalia' },
      ces: { official: 'Somálská demokratická republika', common: 'Somálsko' },
      cym: { official: 'Federal Republic of Somalia', common: 'Somalia' },
      deu: { official: 'Bundesrepublik Somalia', common: 'Somalia' },
      est: { official: 'Somaalia Liitvabariik', common: 'Somaalia' },
      fin: { official: 'Somalian liittotasavalta', common: 'Somalia' },
      fra: { official: 'République fédérale de Somalie', common: 'Somalie' },
      hrv: { official: 'Savezna Republika Somaliji', common: 'Somalija' },
      hun: { official: 'Szomáli Szövetségi Köztársaság', common: 'Szomália' },
      ita: { official: 'Repubblica federale di Somalia', common: 'Somalia' },
      jpn: { official: 'ソマリア連邦共和国', common: 'ソマリア' },
      kor: { official: ' 소말리아 연방 공화국', common: '소말리아' },
      nld: { official: 'Federale Republiek Somalië', common: 'Somalië' },
      per: { official: 'جمهوری فدرال سومالی', common: 'سومالی' },
      pol: { official: 'Federalna Republika Somalii', common: 'Somalia' },
      por: { official: 'República Federal da Somália', common: 'Somália' },
      rus: { official: 'Федеративная Республика Сомали', common: 'Сомали' },
      slk: { official: 'Somálska federatívna republika', common: 'Somálsko' },
      spa: { official: 'República Federal de Somalia', common: 'Somalia' },
      swe: { official: 'Förbundsrepubliken Somalia', common: 'Somalia' },
      tur: { official: 'Somali Federal Cumhuriyeti', common: 'Somali' },
      urd: { official: 'وفاقی جمہوریہ صومالیہ', common: 'صومالیہ' },
      zho: { official: '索马里共和国', common: '索马里' }
    },
    latlng: [10.0, 49.0],
    landlocked: false,
    borders: ['DJI', 'ETH', 'KEN'],
    area: 637657.0,
    demonyms: {
      eng: { f: 'Somali', m: 'Somali' },
      fra: { f: 'Somalienne', m: 'Somalien' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDF4',
    maps: {
      googleMaps: 'https://goo.gl/maps/8of8q7D1a8p7R6Fc9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192799'
    },
    population: 15893219,
    gini: { 2017: 36.8 },
    fifa: 'SOM',
    car: { signs: ['SO'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/so.png',
      svg: 'https://flagcdn.com/so.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/so.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/so.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [2.07, 45.33] },
    postalCode: { format: '@@  #####', regex: '^([A-Z]{2}\\d{5})$' }
  },
  {
    name: {
      common: 'Réunion',
      official: 'Réunion Island',
      nativeName: {
        fra: { official: 'Ile de la Réunion', common: 'La Réunion' }
      }
    },
    tld: ['.re'],
    cca2: 'RE',
    ccn3: '638',
    cca3: 'REU',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+2', suffixes: ['62'] },
    capital: ['Saint-Denis'],
    altSpellings: ['RE', 'Reunion'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'جزيرة لا ريونيون', common: 'لا ريونيون' },
      bre: { official: 'Enez ar Reünion', common: 'Reünion' },
      ces: { official: 'Réunion', common: 'Réunion' },
      cym: { official: 'Réunion Island', common: 'Réunion' },
      deu: { official: 'Réunion', common: 'Réunion' },
      est: { official: 'Réunioni departemang', common: 'Réunion' },
      fin: { official: 'Réunion', common: 'Réunion' },
      fra: { official: 'Ile de la Réunion', common: 'Réunion' },
      hrv: { official: 'Réunion Island', common: 'Réunion' },
      hun: { official: 'Réunion', common: 'Réunion' },
      ita: { official: 'Réunion', common: 'Riunione' },
      jpn: { official: 'レユニオン島', common: 'レユニオン' },
      kor: { official: '레위니옹', common: '레위니옹' },
      nld: { official: 'Réunion', common: 'Réunion' },
      per: { official: 'رئونیون', common: 'رئونیون' },
      pol: { official: 'Reunion', common: 'Reunion' },
      por: { official: 'Ilha da Reunião', common: 'Reunião' },
      rus: { official: 'Реюньон', common: 'Реюньон' },
      slk: { official: 'Réunionský zámorský departmán', common: 'Réunion' },
      spa: { official: 'Isla de la Reunión', common: 'Reunión' },
      swe: { official: 'Réunion', common: 'Réunion' },
      tur: { official: 'Réunion', common: 'Réunion' },
      urd: { official: 'رے یونیوں جزیرہ', common: 'رے یونیوں' },
      zho: { official: '留尼旺岛', common: '留尼旺岛' }
    },
    latlng: [-21.15, 55.5],
    landlocked: false,
    area: 2511.0,
    demonyms: {
      eng: { f: 'Réunionese', m: 'Réunionese' },
      fra: { f: 'Réunionnaise', m: 'Réunionnais' }
    },
    flag: '\uD83C\uDDF7\uD83C\uDDEA',
    maps: {
      googleMaps: 'https://goo.gl/maps/wWpBrXsp8UHVbah29',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1785276'
    },
    population: 840974,
    car: { signs: ['F'], side: 'right' },
    timezones: ['UTC+04:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/re.png',
      svg: 'https://flagcdn.com/re.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-20.88, 55.45] },
    postalCode: { format: '#####', regex: '^((97|98)(4|7|8)\\d{2})$' }
  },
  {
    name: {
      common: 'Libya',
      official: 'State of Libya',
      nativeName: { ara: { official: 'الدولة ليبيا', common: '‏ليبيا' } }
    },
    tld: ['.ly'],
    cca2: 'LY',
    ccn3: '434',
    cca3: 'LBY',
    cioc: 'LBA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { LYD: { name: 'Libyan dinar', symbol: 'ل.د' } },
    idd: { root: '+2', suffixes: ['18'] },
    capital: ['Tripoli'],
    altSpellings: ['LY', 'State of Libya', 'Dawlat Libya'],
    region: 'Africa',
    subregion: 'Northern Africa',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'دولة ليبيا', common: '‏ليبيا' },
      bre: { official: 'Stad Libia', common: 'Libia' },
      ces: { official: 'Stát Libye', common: 'Libye' },
      cym: { official: 'State of Libya', common: 'Libya' },
      deu: { official: 'Staat Libyen', common: 'Libyen' },
      est: { official: 'Liibüa', common: 'Liibüa' },
      fin: { official: 'Libyan valtio', common: 'Libya' },
      fra: {
        official: 'Grande République arabe libyenne populaire et socialiste',
        common: 'Libye'
      },
      hrv: { official: 'Država Libiji', common: 'Libija' },
      hun: { official: 'Líbia Állam', common: 'Líbia' },
      ita: { official: 'Stato della Libia', common: 'Libia' },
      jpn: { official: 'リビアの国家', common: 'リビア' },
      kor: { official: '리비아', common: '리비아' },
      nld: { official: 'Staat van Libië', common: 'Libië' },
      per: { official: 'دولت لیبی', common: 'لیبی' },
      pol: { official: 'Państwo Libia', common: 'Libia' },
      por: { official: 'Estado da Líbia', common: 'Líbia' },
      rus: { official: 'Государство Ливии', common: 'Ливия' },
      slk: { official: 'Líbya', common: 'Líbya' },
      spa: { official: 'Estado de Libia', common: 'Libia' },
      swe: { official: 'Staten Libyen', common: 'Libyen' },
      tur: { official: 'Libya Devleti', common: 'Libya' },
      urd: { official: 'ریاستِ لیبیا', common: 'لیبیا' },
      zho: { official: '利比亚国', common: '利比亚' }
    },
    latlng: [25.0, 17.0],
    landlocked: false,
    borders: ['DZA', 'TCD', 'EGY', 'NER', 'SDN', 'TUN'],
    area: 1759540.0,
    demonyms: {
      eng: { f: 'Libyan', m: 'Libyan' },
      fra: { f: 'Libyenne', m: 'Libyen' }
    },
    flag: '\uD83C\uDDF1\uD83C\uDDFE',
    maps: {
      googleMaps: 'https://goo.gl/maps/eLgGnaQWcJEdYRMy5',
      openStreetMaps: 'openstreetmap.org/relation/192758'
    },
    population: 6871287,
    fifa: 'LBY',
    car: { signs: ['LAR'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ly.png',
      svg: 'https://flagcdn.com/ly.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ly.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ly.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [32.88, 13.17] }
  },
  {
    name: {
      common: 'Republic of the Congo',
      official: 'Republic of the Congo',
      nativeName: {
        fra: { official: 'République du Congo', common: 'République du Congo' },
        kon: { official: 'Repubilika ya Kongo', common: 'Repubilika ya Kongo' },
        lin: { official: 'Republíki ya Kongó', common: 'Republíki ya Kongó' }
      }
    },
    tld: ['.cg'],
    cca2: 'CG',
    ccn3: '178',
    cca3: 'COG',
    cioc: 'CGO',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XAF: { name: 'Central African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['42'] },
    capital: ['Brazzaville'],
    altSpellings: ['CG', 'Congo', 'Congo-Brazzaville'],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { fra: 'French', kon: 'Kikongo', lin: 'Lingala' },
    translations: {
      ara: { official: 'جمهورية الكونغو', common: 'جمهورية الكونفو' },
      bre: { official: 'Republik Kongo', common: 'Kongo-Brazzaville' },
      ces: { official: 'Konžská republika', common: 'Kongo' },
      cym: { official: 'Gweriniaeth y Congo', common: 'Gweriniaeth y Congo' },
      deu: { official: 'Republik Kongo', common: 'Kongo' },
      est: { official: 'Kongo Vabariik', common: 'Kongo Vabariik' },
      fin: { official: 'Kongon tasavalta', common: 'Kongo-Brazzaville' },
      fra: { official: 'République du Congo', common: 'Congo' },
      hrv: { official: 'Republika Kongo', common: 'Kongo' },
      hun: { official: 'Kongói Köztársaság', common: 'Kongói Köztársaság' },
      ita: { official: 'Repubblica del Congo', common: 'Congo' },
      jpn: { official: 'コンゴ共和国', common: 'コンゴ共和国' },
      kor: { official: '콩고', common: '콩고' },
      nld: { official: 'Republiek Congo', common: 'Congo' },
      per: { official: 'جمهوری برازاویل کُنگو', common: 'جمهوری کُنگو' },
      pol: { official: 'Republika Konga', common: 'Kongo' },
      por: { official: 'República do Congo', common: 'Congo' },
      rus: { official: 'Республика Конго', common: 'Республика Конго' },
      slk: { official: 'Konžská republika', common: 'Kongo' },
      spa: { official: 'República del Congo', common: 'Congo' },
      swe: { official: 'Republiken Kongo', common: 'Kongo-Brazzaville' },
      tur: { official: 'Kongo Cumhuriyeti', common: 'Kongo Cumhuriyeti' },
      urd: { official: 'جمہوریہ کانگو', common: 'جمہوریہ کانگو' },
      zho: { official: '刚果共和国', common: '刚果' }
    },
    latlng: [-1.0, 15.0],
    landlocked: false,
    borders: ['AGO', 'CMR', 'CAF', 'COD', 'GAB'],
    area: 342000.0,
    demonyms: {
      eng: { f: 'Congolese', m: 'Congolese' },
      fra: { f: 'Congolaise', m: 'Congolais' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/Phf5dDDKdfCtuBTb6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192794'
    },
    population: 5657000,
    gini: { 2011: 48.9 },
    fifa: 'CGO',
    car: { signs: ['RCB'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/cg.png',
      svg: 'https://flagcdn.com/cg.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-4.25, 15.28] }
  },
  {
    name: {
      common: 'Tanzania',
      official: 'United Republic of Tanzania',
      nativeName: {
        eng: { official: 'United Republic of Tanzania', common: 'Tanzania' },
        swa: { official: 'Jamhuri ya Muungano wa Tanzania', common: 'Tanzania' }
      }
    },
    tld: ['.tz'],
    cca2: 'TZ',
    ccn3: '834',
    cca3: 'TZA',
    cioc: 'TAN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { TZS: { name: 'Tanzanian shilling', symbol: 'Sh' } },
    idd: { root: '+2', suffixes: ['55'] },
    capital: ['Dodoma'],
    altSpellings: [
      'TZ',
      'Tanzania, United Republic of',
      'United Republic of Tanzania',
      'Jamhuri ya Muungano wa Tanzania'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { eng: 'English', swa: 'Swahili' },
    translations: {
      ara: { official: 'جمهورية تنزانيا الاتحادية', common: 'تنزانيا' },
      bre: { official: 'Republik Unanet Tanzania', common: 'Tanzania' },
      ces: { official: 'Sjednocená tanzanská republika', common: 'Tanzanie' },
      cym: { official: 'United Republic of Tanzania', common: 'Tanzania' },
      deu: { official: 'Vereinigte Republik Tansania', common: 'Tansania' },
      est: { official: 'Tansaania Ühendvabariik', common: 'Tansaania' },
      fin: { official: 'Tansanian yhdistynyt tasavalta', common: 'Tansania' },
      fra: { official: 'République -Unie de Tanzanie', common: 'Tanzanie' },
      hrv: { official: 'Ujedinjena Republika Tanzanija', common: 'Tanzanija' },
      hun: { official: 'Tádzsik Köztársaság', common: 'Tádzsikisztán' },
      ita: { official: 'Repubblica Unita di Tanzania', common: 'Tanzania' },
      jpn: { official: 'タンザニア連合共和国', common: 'タンザニア' },
      kor: { official: '탄자니아 연합 공화국', common: '탄자니아' },
      nld: { official: 'Verenigde Republiek Tanzania', common: 'Tanzania' },
      per: { official: 'جمهوری متحد تانزانیا', common: 'تانزانیا' },
      pol: { official: 'Zjednoczona Republika Tanzanii', common: 'Tanzania' },
      por: { official: 'República Unida da Tanzânia', common: 'Tanzânia' },
      rus: { official: 'Объединенная Республика Танзания', common: 'Танзания' },
      slk: { official: 'Tanzánijská zjednotená republika', common: 'Tanzánia' },
      spa: { official: 'República Unida de Tanzania', common: 'Tanzania' },
      swe: { official: 'Förenade republiken Tanzania', common: 'Tanzania' },
      tur: { official: 'Tanzanya Birleşik Cumhuriyeti', common: 'Tanzanya' },
      urd: { official: 'متحدہ جمہوریہ تنزانیہ', common: 'تنزانیہ' },
      zho: { official: '坦桑尼亚联合共和国', common: '坦桑尼亚' }
    },
    latlng: [-6.0, 35.0],
    landlocked: false,
    borders: ['BDI', 'COD', 'KEN', 'MWI', 'MOZ', 'RWA', 'UGA', 'ZMB'],
    area: 945087.0,
    demonyms: {
      eng: { f: 'Tanzanian', m: 'Tanzanian' },
      fra: { f: 'Tanzanienne', m: 'Tanzanien' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDFF',
    maps: {
      googleMaps: 'https://goo.gl/maps/NWYMqZYXte4zGZ2Q8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/195270'
    },
    population: 59734213,
    gini: { 2017: 40.5 },
    fifa: 'TAN',
    car: { signs: ['EAT'], side: 'left' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/tz.png',
      svg: 'https://flagcdn.com/tz.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tz.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tz.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-6.16, 35.75] }
  },
  {
    name: {
      common: 'Kenya',
      official: 'Republic of Kenya',
      nativeName: {
        eng: { official: 'Republic of Kenya', common: 'Kenya' },
        swa: { official: 'Republic of Kenya', common: 'Kenya' }
      }
    },
    tld: ['.ke'],
    cca2: 'KE',
    ccn3: '404',
    cca3: 'KEN',
    cioc: 'KEN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { KES: { name: 'Kenyan shilling', symbol: 'Sh' } },
    idd: { root: '+2', suffixes: ['54'] },
    capital: ['Nairobi'],
    altSpellings: ['KE', 'Republic of Kenya', 'Jamhuri ya Kenya'],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { eng: 'English', swa: 'Swahili' },
    translations: {
      ara: { official: 'جمهورية كينيا', common: 'كينيا' },
      bre: { official: 'Republik Kenya', common: 'Kenya' },
      ces: { official: 'Keňská republika', common: 'Keňa' },
      cym: { official: 'Republic of Kenya', common: 'Kenya' },
      deu: { official: 'Republik Kenia', common: 'Kenia' },
      est: { official: 'Keenia Vabariik', common: 'Keenia' },
      fin: { official: 'Kenian tasavalta', common: 'Kenia' },
      fra: { official: 'République du Kenya', common: 'Kenya' },
      hrv: { official: 'Republika Kenija', common: 'Kenija' },
      hun: { official: 'Kenyai Köztársaság', common: 'Kenya' },
      ita: { official: 'Repubblica del Kenya', common: 'Kenya' },
      jpn: { official: 'ケニア共和国', common: 'ケニア' },
      kor: { official: '케냐 공화국', common: '케냐' },
      nld: { official: 'Republiek Kenia', common: 'Kenia' },
      per: { official: 'جمهوری کنیا', common: 'کنیا' },
      pol: { official: 'Republika Kenii', common: 'Kenia' },
      por: { official: 'República do Quénia', common: 'Quénia' },
      rus: { official: 'Республика Кения', common: 'Кения' },
      slk: { official: 'Kenská republika', common: 'Keňa' },
      spa: { official: 'República de Kenya', common: 'Kenia' },
      swe: { official: 'Republiken Kenya', common: 'Kenya' },
      tur: { official: 'Kenya Cumhuriyeti', common: 'Kenya' },
      urd: { official: 'جمہوریہ کینیا', common: 'کینیا' },
      zho: { official: '肯尼亚共和国', common: '肯尼亚' }
    },
    latlng: [1.0, 38.0],
    landlocked: false,
    borders: ['ETH', 'SOM', 'SSD', 'TZA', 'UGA'],
    area: 580367.0,
    demonyms: {
      eng: { f: 'Kenyan', m: 'Kenyan' },
      fra: { f: 'Kényane', m: 'Kényan' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDEA',
    maps: {
      googleMaps: 'https://goo.gl/maps/Ni9M7wcCxf8bJHLX8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192798'
    },
    population: 53771300,
    gini: { 2015: 40.8 },
    fifa: 'KEN',
    car: { signs: ['EAK'], side: 'left' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ke.png',
      svg: 'https://flagcdn.com/ke.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ke.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ke.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-1.28, 36.82] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Sudan',
      official: 'Republic of the Sudan',
      nativeName: {
        ara: { official: 'جمهورية السودان', common: 'السودان' },
        eng: { official: 'Republic of the Sudan', common: 'Sudan' }
      }
    },
    tld: ['.sd'],
    cca2: 'SD',
    ccn3: '729',
    cca3: 'SDN',
    cioc: 'SUD',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SDG: { name: 'Sudanese pound' } },
    idd: { root: '+2', suffixes: ['49'] },
    capital: ['Khartoum'],
    altSpellings: ['SD', 'Republic of the Sudan', 'Jumhūrīyat as-Sūdān'],
    region: 'Africa',
    subregion: 'Northern Africa',
    languages: { ara: 'Arabic', eng: 'English' },
    translations: {
      ara: { official: 'جمهورية السودان', common: 'السودان' },
      bre: { official: 'Republik Soudan', common: 'Soudan' },
      ces: { official: 'Súdánská republika', common: 'Súdán' },
      cym: { official: 'Republic of the Sudan', common: 'Sudan' },
      deu: { official: 'Republik Sudan', common: 'Sudan' },
      est: { official: 'Sudaani Vabariik', common: 'Sudaan' },
      fin: { official: 'Sudanin tasavalta', common: 'Sudan' },
      fra: { official: 'République du Soudan', common: 'Soudan' },
      hrv: { official: 'Republika Sudan', common: 'Sudan' },
      hun: { official: 'Szudáni Köztársaság', common: 'Szudán' },
      ita: { official: 'Repubblica del Sudan', common: 'Sudan' },
      jpn: { official: 'スーダン共和国', common: 'スーダン' },
      kor: { official: '수단 공화국', common: '수단' },
      nld: { official: 'Republiek Soedan', common: 'Soedan' },
      per: { official: 'جمهوری سودان', common: 'سودان' },
      pol: { official: 'Republika Sudanu', common: 'Sudan' },
      por: { official: 'República do Sudão', common: 'Sudão' },
      rus: { official: 'Республика Судан', common: 'Судан' },
      slk: { official: 'Sudánska republika', common: 'Sudán' },
      spa: { official: 'República de Sudán', common: 'Sudán' },
      swe: { official: 'Republiken Sudan', common: 'Sudan' },
      tur: { official: 'Sudan Cumhuriyeti', common: 'Sudan' },
      urd: { official: 'جمہوریہ سودان', common: 'سودان' },
      zho: { official: '苏丹共和国', common: '苏丹' }
    },
    latlng: [15.0, 30.0],
    landlocked: false,
    borders: ['CAF', 'TCD', 'EGY', 'ERI', 'ETH', 'LBY', 'SSD'],
    area: 1886068.0,
    demonyms: {
      eng: { f: 'Sudanese', m: 'Sudanese' },
      fra: { f: 'Soudanaise', m: 'Soudanais' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDE9',
    maps: {
      googleMaps: 'https://goo.gl/maps/bNW7YUJCaqR8zcXn7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192789'
    },
    population: 43849269,
    gini: { 2014: 34.2 },
    fifa: 'SDN',
    car: { signs: ['SUD'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/sd.png',
      svg: 'https://flagcdn.com/sd.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sd.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sd.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [15.6, 32.53] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Burkina Faso',
      official: 'Burkina Faso',
      nativeName: {
        fra: { official: 'République du Burkina', common: 'Burkina Faso' }
      }
    },
    tld: ['.bf'],
    cca2: 'BF',
    ccn3: '854',
    cca3: 'BFA',
    cioc: 'BUR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XOF: { name: 'West African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['26'] },
    capital: ['Ouagadougou'],
    altSpellings: ['BF'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'بوركينا فاسو', common: 'بوركينا فاسو' },
      bre: { official: 'Burkina Faso', common: 'Burkina Faso' },
      ces: { official: 'Burkina Faso', common: 'Burkina Faso' },
      cym: { official: 'Bwrcina Ffaso', common: 'Bwrcina Ffaso' },
      deu: { official: 'Burkina Faso', common: 'Burkina Faso' },
      est: { official: 'Burkina Faso', common: 'Burkina Faso' },
      fin: { official: 'Burkina Faso', common: 'Burkina Faso' },
      fra: { official: 'République du Burkina', common: 'Burkina Faso' },
      hrv: { official: 'Burkina Faso', common: 'Burkina Faso' },
      hun: { official: 'Burkina Faso', common: 'Burkina' },
      ita: { official: 'Burkina Faso', common: 'Burkina Faso' },
      jpn: { official: 'ブルキナファソ', common: 'ブルキナファソ' },
      kor: { official: '부르키나파소', common: '부르키나파소' },
      nld: { official: 'Burkina Faso', common: 'Burkina Faso' },
      per: { official: 'بورکینافاسو', common: 'بورکینافاسو' },
      pol: { official: 'Burkina Faso', common: 'Burkina Faso' },
      por: { official: 'Burkina Faso', common: 'Burkina Faso' },
      rus: { official: 'Буркина -Фасо', common: 'Буркина-Фасо' },
      slk: { official: 'Burkina Faso', common: 'Burkina Faso' },
      spa: { official: 'Burkina Faso', common: 'Burkina Faso' },
      swe: { official: 'Burkina Faso', common: 'Burkina Faso' },
      tur: { official: 'Burkina Faso', common: 'Burkina Faso' },
      urd: { official: 'برکینا فاسو', common: 'برکینا فاسو' },
      zho: { official: '布基纳法索', common: '布基纳法索' }
    },
    latlng: [13.0, -2.0],
    landlocked: true,
    borders: ['BEN', 'CIV', 'GHA', 'MLI', 'NER', 'TGO'],
    area: 272967.0,
    demonyms: {
      eng: { f: 'Burkinabe', m: 'Burkinabe' },
      fra: { f: 'Burkinabée', m: 'Burkinabé' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDEB',
    maps: {
      googleMaps: 'https://goo.gl/maps/rKRmpcMbFher2ozb7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192783'
    },
    population: 20903278,
    gini: { 2014: 35.3 },
    fifa: 'BFA',
    car: { signs: ['BF'], side: 'right' },
    timezones: ['UTC'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/bf.png',
      svg: 'https://flagcdn.com/bf.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bf.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bf.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [12.37, -1.52] }
  },
  {
    name: {
      common: 'Ethiopia',
      official: 'Federal Democratic Republic of Ethiopia',
      nativeName: {
        amh: { official: 'የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ', common: 'ኢትዮጵያ' }
      }
    },
    tld: ['.et'],
    cca2: 'ET',
    ccn3: '231',
    cca3: 'ETH',
    cioc: 'ETH',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { ETB: { name: 'Ethiopian birr', symbol: 'Br' } },
    idd: { root: '+2', suffixes: ['51'] },
    capital: ['Addis Ababa'],
    altSpellings: [
      'ET',
      'ʾĪtyōṗṗyā',
      'Federal Democratic Republic of Ethiopia',
      'የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { amh: 'Amharic' },
    translations: {
      ara: {
        official: 'جمهورية إثيوبيا الفدرالية الديموقراطية',
        common: 'إثيوبيا'
      },
      bre: {
        official: 'Republik Demokratel Kevredadel Etiopia',
        common: 'Etiopia'
      },
      ces: {
        official: 'Etiopská federativní demokratická republika',
        common: 'Etiopie'
      },
      cym: {
        official: 'Gweriniaeth Ddemocrataidd Ffederal Ethiopia',
        common: 'Ethiopia'
      },
      deu: {
        official: 'Demokratische Bundesrepublik Äthiopien',
        common: 'Äthiopien'
      },
      est: {
        official: 'Etioopia Demokraatlik Liitvabariik',
        common: 'Etioopia'
      },
      fin: {
        official: 'Etiopian demokraattinen liittotasavalta',
        common: 'Etiopia'
      },
      fra: {
        official: "République fédérale démocratique d'Éthiopie",
        common: 'Éthiopie'
      },
      hrv: {
        official: 'Savezna Demokratska Republika Etiopija',
        common: 'Etiopija'
      },
      hun: {
        official: 'Etióp Szövetségi Demokratikus Köztársaság',
        common: 'Etiópia'
      },
      ita: {
        official: 'Repubblica federale democratica di Etiopia',
        common: 'Etiopia'
      },
      jpn: { official: 'エチオピア連邦民主共和国', common: 'エチオピア' },
      kor: { official: '에티오피아 연방 민주 공화국', common: '에티오피아' },
      nld: {
        official: 'Federale Democratische Republiek Ethiopië',
        common: 'Ethiopië'
      },
      per: { official: 'جمهوری فدرال دموکراتیک اتیوپی', common: 'اِتیوپی' },
      pol: {
        official: 'Federalna Demokratyczna Republika Etiopii',
        common: 'Etiopia'
      },
      por: {
        official: 'República Federal Democrática da Etiópia',
        common: 'Etiópia'
      },
      rus: {
        official: 'Федеративная Демократическая Республика Эфиопия',
        common: 'Эфиопия'
      },
      slk: {
        official: 'Etiópska federatívna demokratická republika',
        common: 'Etiópia'
      },
      spa: {
        official: 'República Democrática Federal de Etiopía',
        common: 'Etiopía'
      },
      swe: {
        official: 'Demokratiska förbundsrepubliken Etiopien',
        common: 'Etiopien'
      },
      tur: {
        official: 'Etiyopya Federal Demokratik Cumhuriyeti',
        common: 'Etiyopya'
      },
      urd: { official: 'وفاقی جمہوری جمہوریہ ایتھوپیا', common: 'ایتھوپیا' },
      zho: { official: '埃塞俄比亚联邦民主共和国', common: '埃塞俄比亚' }
    },
    latlng: [8.0, 38.0],
    landlocked: true,
    borders: ['DJI', 'ERI', 'KEN', 'SOM', 'SSD', 'SDN'],
    area: 1104300.0,
    demonyms: {
      eng: { f: 'Ethiopian', m: 'Ethiopian' },
      fra: { f: 'Éthiopienne', m: 'Éthiopien' }
    },
    flag: '\uD83C\uDDEA\uD83C\uDDF9',
    maps: {
      googleMaps: 'https://goo.gl/maps/2Q4hQWCbhuZLj3fG6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192800'
    },
    population: 114963583,
    gini: { 2015: 35.0 },
    fifa: 'ETH',
    car: { signs: ['ETH'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/et.png',
      svg: 'https://flagcdn.com/et.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/et.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/et.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [9.03, 38.7] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Madagascar',
      official: 'Republic of Madagascar',
      nativeName: {
        fra: { official: 'République de Madagascar', common: 'Madagascar' },
        mlg: { official: "Repoblikan'i Madagasikara", common: 'Madagasikara' }
      }
    },
    tld: ['.mg'],
    cca2: 'MG',
    ccn3: '450',
    cca3: 'MDG',
    cioc: 'MAD',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MGA: { name: 'Malagasy ariary', symbol: 'Ar' } },
    idd: { root: '+2', suffixes: ['61'] },
    capital: ['Antananarivo'],
    altSpellings: [
      'MG',
      'Republic of Madagascar',
      "Repoblikan'i Madagasikara",
      'République de Madagascar'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { fra: 'French', mlg: 'Malagasy' },
    translations: {
      ara: { official: 'جمهورية مدغشقر', common: 'مدغشقر' },
      bre: { official: 'Republik Madagaskar', common: 'Madagaskar' },
      ces: { official: 'Madagaskarská republika', common: 'Madagaskar' },
      cym: { official: 'Republic of Madagascar', common: 'Madagascar' },
      deu: { official: 'Republik Madagaskar', common: 'Madagaskar' },
      est: { official: 'Madagaskari Vabariik', common: 'Madagaskar' },
      fin: { official: 'Madagaskarin tasavalta', common: 'Madagaskar' },
      fra: { official: 'République de Madagascar', common: 'Madagascar' },
      hrv: { official: 'Republika Madagaskar', common: 'Madagaskar' },
      hun: { official: 'Madagaszkári Köztársaság', common: 'Madagaszkár' },
      ita: { official: 'Repubblica del Madagascar', common: 'Madagascar' },
      jpn: { official: 'マダガスカル共和国', common: 'マダガスカル' },
      kor: { official: '마다가스카르 공화국', common: '마다가스카르' },
      nld: { official: 'Republiek Madagaskar', common: 'Madagaskar' },
      per: { official: 'جمهوری ماداگاسکار', common: 'ماداگاسکار' },
      pol: { official: 'Republika Madagaskaru', common: 'Madagaskar' },
      por: { official: 'República de Madagáscar', common: 'Madagáscar' },
      rus: { official: 'Республика Мадагаскар', common: 'Мадагаскар' },
      slk: { official: 'Madagaskarská republika', common: 'Madagaskar' },
      spa: { official: 'República de Madagascar', common: 'Madagascar' },
      swe: { official: 'Republiken Madagaskar', common: 'Madagaskar' },
      tur: { official: 'Madagaskar Cumhuriyeti', common: 'Madagaskar' },
      urd: { official: 'جمہوریہ مڈغاسکر', common: 'مڈغاسکر' },
      zho: { official: '马达加斯加共和国', common: '马达加斯加' }
    },
    latlng: [-20.0, 47.0],
    landlocked: false,
    area: 587041.0,
    demonyms: {
      eng: { f: 'Malagasy', m: 'Malagasy' },
      fra: { f: 'Malgache', m: 'Malgache' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/AHQh2ABBaFW6Ngj26',
      openStreetMaps: 'https://www.openstreetmap.org/relation/447325'
    },
    population: 27691019,
    gini: { 2012: 42.6 },
    fifa: 'MAD',
    car: { signs: ['RM'], side: 'right' },
    timezones: ['UTC+03:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/mg.png',
      svg: 'https://flagcdn.com/mg.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mg.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mg.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-18.92, 47.52] },
    postalCode: { format: '###', regex: '^(\\d{3})$' }
  },
  {
    name: {
      common: 'Equatorial Guinea',
      official: 'Republic of Equatorial Guinea',
      nativeName: {
        fra: {
          official: 'République de la Guinée Équatoriale',
          common: 'Guinée équatoriale'
        },
        por: {
          official: 'República da Guiné Equatorial',
          common: 'Guiné Equatorial'
        },
        spa: {
          official: 'República de Guinea Ecuatorial',
          common: 'Guinea Ecuatorial'
        }
      }
    },
    tld: ['.gq'],
    cca2: 'GQ',
    ccn3: '226',
    cca3: 'GNQ',
    cioc: 'GEQ',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XAF: { name: 'Central African CFA franc', symbol: 'Fr' } },
    idd: { root: '+2', suffixes: ['40'] },
    capital: ['Malabo'],
    altSpellings: [
      'GQ',
      'Republic of Equatorial Guinea',
      'República de Guinea Ecuatorial',
      'République de Guinée équatoriale',
      'República da Guiné Equatorial'
    ],
    region: 'Africa',
    subregion: 'Middle Africa',
    languages: { fra: 'French', por: 'Portuguese', spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية غينيا الاستوائية', common: 'غينيا الاستوائية' },
      bre: {
        official: "Republik Ginea ar C'heheder",
        common: "Ginea ar C'heheder"
      },
      ces: {
        official: 'Republika Rovníková Guinea',
        common: 'Rovníková Guinea'
      },
      cym: {
        official: 'Gweriniaeth Gini Gyhydeddol',
        common: 'Gini Gyhydeddol'
      },
      deu: {
        official: 'Republik Äquatorialguinea',
        common: 'Äquatorialguinea'
      },
      est: {
        official: 'Ekvatoriaal-Guinea Vabariik',
        common: 'Ekvatoriaal-Guinea'
      },
      fin: {
        official: 'Päiväntasaajan Guinean tasavalta',
        common: 'Päiväntasaajan Guinea'
      },
      fra: {
        official: 'République de Guinée équatoriale',
        common: 'Guinée équatoriale'
      },
      hrv: {
        official: 'Republika Ekvatorska Gvineja',
        common: 'Ekvatorijalna Gvineja'
      },
      hun: {
        official: 'Egyenlítői-Guinea-i Köztársaság',
        common: 'Egyenlítői-Guinea'
      },
      ita: {
        official: 'Repubblica della Guinea Equatoriale',
        common: 'Guinea Equatoriale'
      },
      jpn: { official: '赤道ギニア共和国', common: '赤道ギニア' },
      kor: { official: '적도 기니 공화국', common: '적도 기니' },
      nld: {
        official: 'Republiek Equatoriaal-Guinea',
        common: 'Equatoriaal-Guinea'
      },
      per: { official: 'جمهوری گینه استوایی', common: 'گینه استوایی' },
      pol: {
        official: 'Republika Gwinei Równikowej',
        common: 'Gwinea Równikowa'
      },
      por: {
        official: 'República da Guiné Equatorial',
        common: 'Guiné Equatorial'
      },
      rus: {
        official: 'Республика Экваториальная Гвинея',
        common: 'Экваториальная Гвинея'
      },
      slk: {
        official: 'Republika rovníkovej Guiney',
        common: 'Rovníková Guinea'
      },
      spa: {
        official: 'República de Guinea Ecuatorial',
        common: 'Guinea Ecuatorial'
      },
      swe: {
        official: 'Republiken Ekvatorialguinea',
        common: 'Ekvatorialguinea'
      },
      tur: { official: 'Ekvator Ginesi Cumhuriyeti', common: 'Ekvator Ginesi' },
      urd: { official: 'جمہوریہ استوائی گنی', common: 'استوائی گنی' },
      zho: { official: '赤道几内亚共和国', common: '赤道几内亚' }
    },
    latlng: [2.0, 10.0],
    landlocked: false,
    borders: ['CMR', 'GAB'],
    area: 28051.0,
    demonyms: {
      eng: { f: 'Equatorial Guinean', m: 'Equatorial Guinean' },
      fra: { f: 'Équato-guinéenne', m: 'Équato-guinéen' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDF6',
    maps: {
      googleMaps: 'https://goo.gl/maps/ucWfFd8aW1FbGMva9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192791'
    },
    population: 1402985,
    fifa: 'EQG',
    car: { signs: ['GQ'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/gq.png',
      svg: 'https://flagcdn.com/gq.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gq.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gq.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [3.75, 8.78] }
  },
  {
    name: {
      common: 'Egypt',
      official: 'Arab Republic of Egypt',
      nativeName: { ara: { official: 'جمهورية مصر العربية', common: 'مصر' } }
    },
    tld: ['.eg', '.مصر'],
    cca2: 'EG',
    ccn3: '818',
    cca3: 'EGY',
    cioc: 'EGY',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { EGP: { name: 'Egyptian pound', symbol: '£' } },
    idd: { root: '+2', suffixes: ['0'] },
    capital: ['Cairo'],
    altSpellings: ['EG', 'Arab Republic of Egypt'],
    region: 'Africa',
    subregion: 'Northern Africa',
    languages: { ara: 'Arabic' },
    translations: {
      ara: { official: 'جمهورية مصر العربية', common: 'مصر' },
      bre: { official: 'Republik arab Egipt', common: 'Egipt' },
      ces: { official: 'Egyptská arabská republika', common: 'Egypt' },
      cym: { official: 'Gweriniaeth Arabaidd yr Aifft', common: 'Yr Aifft' },
      deu: { official: 'Arabische Republik Ägypten', common: 'Ägypten' },
      est: { official: 'Egiptuse Araabia Vabariik', common: 'Egiptus' },
      fin: { official: 'Egyptin arabitasavalta', common: 'Egypti' },
      fra: { official: "République arabe d'Égypte", common: 'Égypte' },
      hrv: { official: 'Arapska Republika Egipat', common: 'Egipat' },
      hun: { official: 'Egyiptomi Arab Köztársaság', common: 'Egyiptom' },
      ita: { official: "Repubblica araba d'Egitto", common: 'Egitto' },
      jpn: { official: 'エジプト·アラブ共和国', common: 'エジプト' },
      kor: { official: '이집트 아랍 공화국', common: '이집트' },
      nld: { official: 'Arabische Republiek Egypte', common: 'Egypte' },
      per: { official: 'جمهوری عربی مصر', common: 'مصر' },
      pol: { official: 'Arabska Republika Egiptu', common: 'Egipt' },
      por: { official: 'República Árabe do Egipto', common: 'Egito' },
      rus: { official: 'Арабская Республика Египет', common: 'Египет' },
      slk: { official: 'Egyptská arabská republika', common: 'Egypt' },
      spa: { official: 'República Árabe de Egipto', common: 'Egipto' },
      swe: { official: 'Arabrepubliken Egypten', common: 'Egypten' },
      tur: { official: 'Mısır Arap Cumhuriyeti', common: 'Mısır' },
      urd: { official: 'مصری عرب جمہوریہ', common: 'مصر' },
      zho: { official: '阿拉伯埃及共和国', common: '埃及' }
    },
    latlng: [27.0, 30.0],
    landlocked: false,
    borders: ['ISR', 'LBY', 'PSE', 'SDN'],
    area: 1002450.0,
    demonyms: {
      eng: { f: 'Egyptian', m: 'Egyptian' },
      fra: { f: 'Égyptienne', m: 'Égyptien' }
    },
    flag: '\uD83C\uDDEA\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/uoDRhXbsqjG6L7VG7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1473947'
    },
    population: 102334403,
    gini: { 2017: 31.5 },
    fifa: 'EGY',
    car: { signs: ['ET'], side: 'right' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/eg.png',
      svg: 'https://flagcdn.com/eg.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/eg.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/eg.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [30.05, 31.25] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Algeria',
      official: "People's Democratic Republic of Algeria",
      nativeName: {
        ara: {
          official: 'الجمهورية الديمقراطية الشعبية الجزائرية',
          common: 'الجزائر'
        }
      }
    },
    tld: ['.dz', 'الجزائر.'],
    cca2: 'DZ',
    ccn3: '012',
    cca3: 'DZA',
    cioc: 'ALG',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { DZD: { name: 'Algerian dinar', symbol: 'د.ج' } },
    idd: { root: '+2', suffixes: ['13'] },
    capital: ['Algiers'],
    altSpellings: ['DZ', 'Dzayer', 'Algérie'],
    region: 'Africa',
    subregion: 'Northern Africa',
    languages: { ara: 'Arabic' },
    translations: {
      ara: {
        official: 'الجمهورية الديمقراطية الشعبية الجزائرية',
        common: 'الجزائر'
      },
      bre: {
        official: 'Republik Aljerian Demokratel ha Poblel',
        common: 'Aljeria'
      },
      ces: {
        official: 'Alžírská demokratická a lidová republika',
        common: 'Alžírsko'
      },
      cym: {
        official: 'Gweriniaeth Ddemocrataidd Pobl Algeria',
        common: 'Algeria'
      },
      deu: {
        official: 'Demokratische Volksrepublik Algerien',
        common: 'Algerien'
      },
      est: {
        official: 'Alžeeria Demokraatlik Rahvavabariik',
        common: 'Alžeeria'
      },
      fin: {
        official: 'Algerian demokraattinen kansantasavalta',
        common: 'Algeria'
      },
      fra: {
        official: "République démocratique et populaire d'Algérie",
        common: 'Algérie'
      },
      hrv: { official: 'Narodna Demokratska Republika Alžir', common: 'Alžir' },
      hun: {
        official: 'Algériai Népi Demokratikus Köztársaság',
        common: 'Algéria'
      },
      ita: {
        official: 'Repubblica popolare democratica di Algeria',
        common: 'Algeria'
      },
      jpn: { official: 'アルジェリア人民民主共和国', common: 'アルジェリア' },
      kor: { official: '알제리 인민 민주 공화국', common: '알제리' },
      nld: {
        official: 'Democratische Volksrepubliek Algerije',
        common: 'Algerije'
      },
      per: { official: 'جمهوری دموکراتیک خلق الجزایر', common: 'الجزایر' },
      pol: {
        official: 'Algierska Republika Ludowo-Demokratyczna',
        common: 'Algieria'
      },
      por: {
        official: 'República Argelina Democrática e Popular',
        common: 'Argélia'
      },
      rus: {
        official: 'Народно-Демократическая Республика Алжир',
        common: 'Алжир'
      },
      slk: {
        official: 'Alžírska demokratická ľudová republika',
        common: 'Alžírsko'
      },
      spa: {
        official: 'República Argelina Democrática y Popular',
        common: 'Argelia'
      },
      swe: {
        official: 'Demokratiska folkrepubliken Algeriet',
        common: 'Algeriet'
      },
      tur: {
        official: 'Cezayir Demokratik Halk Cumhuriyeti',
        common: 'Cezayir'
      },
      urd: { official: 'عوامی جمہوری جمہوریہ الجزائر', common: 'الجزائر' },
      zho: { official: '阿尔及利亚人民民主共和国', common: '阿尔及利亚' }
    },
    latlng: [28.0, 3.0],
    landlocked: false,
    borders: ['TUN', 'LBY', 'NER', 'ESH', 'MRT', 'MLI', 'MAR'],
    area: 2381741.0,
    demonyms: {
      eng: { f: 'Algerian', m: 'Algerian' },
      fra: { f: 'Algérienne', m: 'Algérien' }
    },
    flag: '\uD83C\uDDE9\uD83C\uDDFF',
    maps: {
      googleMaps: 'https://goo.gl/maps/RsAyAfyaiNVb8DpW8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/192756'
    },
    population: 44700000,
    gini: { 2011: 27.6 },
    fifa: 'ALG',
    car: { signs: ['DZ'], side: 'right' },
    timezones: ['UTC+01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/dz.png',
      svg: 'https://flagcdn.com/dz.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/dz.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/dz.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [36.75, 3.05] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Lesotho',
      official: 'Kingdom of Lesotho',
      nativeName: {
        eng: { official: 'Kingdom of Lesotho', common: 'Lesotho' },
        sot: { official: 'Kingdom of Lesotho', common: 'Lesotho' }
      }
    },
    tld: ['.ls'],
    cca2: 'LS',
    ccn3: '426',
    cca3: 'LSO',
    cioc: 'LES',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      LSL: { name: 'Lesotho loti', symbol: 'L' },
      ZAR: { name: 'South African rand', symbol: 'R' }
    },
    idd: { root: '+2', suffixes: ['66'] },
    capital: ['Maseru'],
    altSpellings: ['LS', 'Kingdom of Lesotho', 'Muso oa Lesotho'],
    region: 'Africa',
    subregion: 'Southern Africa',
    languages: { eng: 'English', sot: 'Sotho' },
    translations: {
      ara: { official: 'مملكة ليسوتو', common: 'ليسوتو' },
      bre: { official: 'Rouantelezh Lesotho', common: 'Lesotho' },
      ces: { official: 'Lesothské království', common: 'Lesotho' },
      cym: { official: 'Kingdom of Lesotho', common: 'Lesotho' },
      deu: { official: 'Königreich Lesotho', common: 'Lesotho' },
      est: { official: 'Lesotho Kuningriik', common: 'Lesotho' },
      fin: { official: 'Lesothon kuningaskunta', common: 'Lesotho' },
      fra: { official: 'Royaume du Lesotho', common: 'Lesotho' },
      hrv: { official: 'Kraljevina Lesoto', common: 'Lesoto' },
      hun: { official: 'Lesothói Királyság', common: 'Lesotho' },
      ita: { official: 'Regno del Lesotho', common: 'Lesotho' },
      jpn: { official: 'レソト王国', common: 'レソト' },
      kor: { official: '레소토 왕국', common: '레소토' },
      nld: { official: 'Koninkrijk Lesotho', common: 'Lesotho' },
      per: { official: 'پادشاهی لسوتو', common: 'لسوتو' },
      pol: { official: 'Królestwo Lesotho', common: 'Lesotho' },
      por: { official: 'Reino do Lesoto', common: 'Lesoto' },
      rus: { official: 'Королевство Лесото', common: 'Лесото' },
      slk: { official: 'Lesothské kráľovstvo', common: 'Lesotho' },
      spa: { official: 'Reino de Lesotho', common: 'Lesotho' },
      swe: { official: 'Konungariket Lesotho', common: 'Lesotho' },
      tur: { official: 'Lesotho Krallığı', common: 'Lesotho' },
      urd: { official: 'مملکتِ لیسوتھو', common: 'لیسوتھو' },
      zho: { official: '莱索托王国', common: '莱索托' }
    },
    latlng: [-29.5, 28.5],
    landlocked: true,
    borders: ['ZAF'],
    area: 30355.0,
    demonyms: {
      eng: { f: 'Mosotho', m: 'Mosotho' },
      fra: { f: 'Lésothienne', m: 'Lésothien' }
    },
    flag: '\uD83C\uDDF1\uD83C\uDDF8',
    maps: {
      googleMaps: 'https://goo.gl/maps/H8gJi5mL4Cmd1SF28',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2093234'
    },
    population: 2142252,
    gini: { 2017: 44.9 },
    fifa: 'LES',
    car: { signs: ['LS'], side: 'left' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/ls.png',
      svg: 'https://flagcdn.com/ls.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ls.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ls.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-29.32, 27.48] },
    postalCode: { format: '###', regex: '^(\\d{3})$' }
  },
  {
    name: {
      common: 'Seychelles',
      official: 'Republic of Seychelles',
      nativeName: {
        crs: { official: 'Repiblik Sesel', common: 'Sesel' },
        eng: { official: 'Republic of Seychelles', common: 'Seychelles' },
        fra: { official: 'République des Seychelles', common: 'Seychelles' }
      }
    },
    tld: ['.sc'],
    cca2: 'SC',
    ccn3: '690',
    cca3: 'SYC',
    cioc: 'SEY',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SCR: { name: 'Seychellois rupee', symbol: '₨' } },
    idd: { root: '+2', suffixes: ['48'] },
    capital: ['Victoria'],
    altSpellings: [
      'SC',
      'Republic of Seychelles',
      'Repiblik Sesel',
      'République des Seychelles'
    ],
    region: 'Africa',
    subregion: 'Eastern Africa',
    languages: { crs: 'Seychellois Creole', eng: 'English', fra: 'French' },
    translations: {
      ara: { official: 'جمهورية سيشل', common: 'سيشل' },
      bre: { official: 'Republik Sechelez', common: 'Sechelez' },
      ces: { official: 'Seychelská republika', common: 'Seychely' },
      cym: { official: 'Republic of Seychelles', common: 'Seychelles' },
      deu: { official: 'Republik der Seychellen', common: 'Seychellen' },
      est: { official: 'Seišelli Vabariik', common: 'Seišellid' },
      fin: { official: 'Seychellien tasavalta', common: 'Seychellit' },
      fra: { official: 'République des Seychelles', common: 'Seychelles' },
      hrv: { official: 'Republika Sejšeli', common: 'Sejšeli' },
      hun: { official: 'Seychelle Köztársaság', common: 'Seychelle-szigetek' },
      ita: { official: 'Repubblica delle Seychelles', common: 'Seychelles' },
      jpn: { official: 'セイシェル共和国', common: 'セーシェル' },
      kor: { official: '세이셸 공화국', common: '세이셸' },
      nld: { official: 'Republiek der Seychellen', common: 'Seychellen' },
      per: { official: 'جمهوری سیشل', common: 'سیشل' },
      pol: { official: 'Republika Seszeli', common: 'Seszele' },
      por: { official: 'República das Seychelles', common: 'Seicheles' },
      rus: {
        official: 'Республика Сейшельские Острова',
        common: 'Сейшельские Острова'
      },
      slk: { official: 'Seychelská republika', common: 'Seychely' },
      spa: { official: 'República de las Seychelles', common: 'Seychelles' },
      swe: { official: 'Republiken Seychellerna', common: 'Seychellerna' },
      tur: { official: 'Seyşeller Cumhuriyeti', common: 'Seyşeller' },
      urd: { official: 'جمہوریہ سیچیلیس', common: 'سیچیلیس' },
      zho: { official: '塞舌尔共和国', common: '塞舌尔' }
    },
    latlng: [-4.58333333, 55.66666666],
    landlocked: false,
    area: 452.0,
    demonyms: {
      eng: { f: 'Seychellois', m: 'Seychellois' },
      fra: { f: 'Seychelloise', m: 'Seychellois' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDE8',
    maps: {
      googleMaps: 'https://goo.gl/maps/aqCcy2TKh5TV5MAX8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/536765'
    },
    population: 98462,
    gini: { 2018: 32.1 },
    fifa: 'SEY',
    car: { signs: ['SY'], side: 'left' },
    timezones: ['UTC+04:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/sc.png',
      svg: 'https://flagcdn.com/sc.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sc.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sc.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-4.62, 55.45] }
  },
  {
    name: {
      common: 'Zimbabwe',
      official: 'Republic of Zimbabwe',
      nativeName: {
        bwg: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        eng: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        kck: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        khi: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        ndc: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        nde: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        nya: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        sna: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        sot: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        toi: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        tsn: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        tso: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        ven: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        xho: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
        zib: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' }
      }
    },
    tld: ['.zw'],
    cca2: 'ZW',
    ccn3: '716',
    cca3: 'ZWE',
    cioc: 'ZIM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { ZWL: { name: 'Zimbabwean dollar', symbol: '$' } },
    idd: { root: '+2', suffixes: ['63'] },
    capital: ['Harare'],
    altSpellings: ['ZW', 'Republic of Zimbabwe'],
    region: 'Africa',
    subregion: 'Southern Africa',
    languages: {
      bwg: 'Chibarwe',
      eng: 'English',
      kck: 'Kalanga',
      khi: 'Khoisan',
      ndc: 'Ndau',
      nde: 'Northern Ndebele',
      nya: 'Chewa',
      sna: 'Shona',
      sot: 'Sotho',
      toi: 'Tonga',
      tsn: 'Tswana',
      tso: 'Tsonga',
      ven: 'Venda',
      xho: 'Xhosa',
      zib: 'Zimbabwean Sign Language'
    },
    translations: {
      ara: { official: 'جمهورية زيمبابوي', common: 'زيمبابوي' },
      bre: { official: 'Republik Zimbabwe', common: 'Zimbabwe' },
      ces: { official: 'Zimbabwská republika', common: 'Zimbabwe' },
      cym: { official: 'Republic of Zimbabwe', common: 'Zimbabwe' },
      deu: { official: 'Republik Simbabwe', common: 'Simbabwe' },
      est: { official: 'Zimbabwe Vabariik', common: 'Zimbabwe' },
      fin: { official: 'Zimbabwen tasavalta', common: 'Zimbabwe' },
      fra: { official: 'République du Zimbabwe', common: 'Zimbabwe' },
      hrv: { official: 'Republika Zimbabve', common: 'Zimbabve' },
      hun: { official: 'Zimbabwei Köztársaság', common: 'Zimbabwe' },
      ita: { official: 'Repubblica dello Zimbabwe', common: 'Zimbabwe' },
      jpn: { official: 'ジンバブエ共和国', common: 'ジンバブエ' },
      kor: { official: '짐바브웨 공화국', common: '짐바브웨' },
      nld: { official: 'Republiek Zimbabwe', common: 'Zimbabwe' },
      per: { official: 'جمهوری زیمبابوه', common: 'زیمبابوه' },
      pol: { official: 'Republika Zimbabwe', common: 'Zimbabwe' },
      por: { official: 'República do Zimbabwe', common: 'Zimbabwe' },
      rus: { official: 'Республика Зимбабве', common: 'Зимбабве' },
      slk: { official: 'Zimbabwianska republika', common: 'Zimbabwe' },
      spa: { official: 'República de Zimbabue', common: 'Zimbabue' },
      swe: { official: 'Republiken Zimbabwe', common: 'Zimbabwe' },
      tur: { official: 'Zimbabve Cumhuriyeti', common: 'Zimbabve' },
      urd: { official: 'جمہوریہ زمبابوے', common: 'زمبابوے' },
      zho: { official: '津巴布韦共和国', common: '津巴布韦' }
    },
    latlng: [-20.0, 30.0],
    landlocked: true,
    borders: ['BWA', 'MOZ', 'ZAF', 'ZMB'],
    area: 390757.0,
    demonyms: {
      eng: { f: 'Zimbabwean', m: 'Zimbabwean' },
      fra: { f: 'Zimbabwéenne', m: 'Zimbabwéen' }
    },
    flag: '\uD83C\uDDFF\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/M26BqdwQctqxXS65A',
      openStreetMaps: 'https://www.openstreetmap.org/relation/195272'
    },
    population: 14862927,
    gini: { 2019: 50.3 },
    fifa: 'ZIM',
    car: { signs: ['ZW'], side: 'left' },
    timezones: ['UTC+02:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/zw.png',
      svg: 'https://flagcdn.com/zw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/zw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/zw.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-17.82, 31.03] }
  },
  {
    name: {
      common: 'Cape Verde',
      official: 'Republic of Cabo Verde',
      nativeName: {
        por: { official: 'República de Cabo Verde', common: 'Cabo Verde' }
      }
    },
    tld: ['.cv'],
    cca2: 'CV',
    ccn3: '132',
    cca3: 'CPV',
    cioc: 'CPV',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { CVE: { name: 'Cape Verdean escudo', symbol: 'Esc' } },
    idd: { root: '+2', suffixes: ['38'] },
    capital: ['Praia'],
    altSpellings: ['CV', 'Republic of Cabo Verde', 'República de Cabo Verde'],
    region: 'Africa',
    subregion: 'Western Africa',
    languages: { por: 'Portuguese' },
    translations: {
      ara: { official: 'جمهورية كابو فيردي', common: 'كابو فيردي' },
      bre: { official: 'Republik Kab Glas', common: 'Kab Glas' },
      ces: { official: 'Kapverdská republika', common: 'Kapverdy' },
      cym: { official: 'Gweriniaeth Cabo Verde', common: 'Penrhyn Verde' },
      deu: { official: 'Republik Cabo Verde', common: 'Kap Verde' },
      est: { official: 'Cabo Verde Vabariik', common: 'Roheneemesaared' },
      fin: { official: 'Kap Verden tasavalta', common: 'Kap Verde' },
      fra: { official: 'République du Cap-Vert', common: 'Îles du Cap-Vert' },
      hrv: {
        official: 'Republika Cabo Verde',
        common: 'Zelenortska Republika'
      },
      hun: {
        official: 'Zöld-foki Köztársaság',
        common: 'Zöld-foki Köztársaság'
      },
      ita: { official: 'Repubblica di Capo Verde', common: 'Capo Verde' },
      jpn: { official: 'カーボベルデ共和国', common: 'カーボベルデ' },
      kor: { official: '카보베르데 공화국', common: '카보베르데' },
      nld: { official: 'Republiek van Cabo Verde', common: 'Kaapverdië' },
      per: { official: 'جمهوری کبو ورد', common: 'دماغهٔ سبز' },
      pol: {
        official: 'Republika Zielonego Przylądka',
        common: 'Republika Zielonego Przylądka'
      },
      por: { official: 'República de Cabo Verde', common: 'Cabo Verde' },
      rus: { official: 'Республика Кабо -Верде', common: 'Кабо-Верде' },
      slk: { official: 'Kapverdská republika', common: 'Kapverdy' },
      spa: { official: 'República de Cabo Verde', common: 'Cabo Verde' },
      swe: { official: 'Republiken Kap Verde', common: 'Kap Verde' },
      tur: { official: 'Yeşil Burun Cumhuriyeti', common: 'Yeşil Burun' },
      urd: { official: 'جمہوریہ کیپ ورڈی', common: 'کیپ ورڈی' },
      zho: { official: '佛得角共和国', common: '佛得角' }
    },
    latlng: [16.0, -24.0],
    landlocked: false,
    area: 4033.0,
    demonyms: {
      eng: { f: 'Cape Verdian', m: 'Cape Verdian' },
      fra: { f: 'Cap-verdienne', m: 'Cap-verdien' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDFB',
    maps: {
      googleMaps: 'https://goo.gl/maps/Kc9vy5ChjuiAgMfXA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/535774'
    },
    population: 555988,
    gini: { 2015: 42.4 },
    fifa: 'CPV',
    car: { signs: ['CV'], side: 'right' },
    timezones: ['UTC-01:00'],
    continents: ['Africa'],
    flags: {
      png: 'https://flagcdn.com/w320/cv.png',
      svg: 'https://flagcdn.com/cv.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cv.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cv.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [14.92, -23.52] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  }
]
